import { GraphQLClient } from 'graphql-request';
import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };

function fetcher<TData, TVariables extends { [key: string]: any }>(
  client: GraphQLClient,
  query: string,
  variables?: TVariables,
  requestHeaders?: RequestInit['headers']
) {
  return async (): Promise<TData> =>
    client.request({
      document: query,
      variables,
      requestHeaders,
    });
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  JSON: { input: any; output: any };
};

export type AppliedPromocode = {
  __typename?: 'AppliedPromocode';
  code: Scalars['String']['output'];
  discountInCents: Scalars['Int']['output'];
  priceInCents: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type Audient = {
  __typename?: 'Audient';
  customer?: Maybe<User>;
  id: Scalars['ID']['output'];
  joinedAt?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  tier?: Maybe<Tier>;
};

export type AuthInvite = {
  __typename?: 'AuthInvite';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  owner: AuthInviteOwner;
  promocode?: Maybe<AuthorSubscriptionPromocode>;
};

export type AuthInviteOwner = {
  __typename?: 'AuthInviteOwner';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type AuthorSubscription = {
  __typename?: 'AuthorSubscription';
  activatedAt?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<AuthorSubscriptionPlanFrequency>;
  hasPromocodeApplied?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nextPaymentAt?: Maybe<Scalars['String']['output']>;
};

export type AuthorSubscriptionPlan = {
  __typename?: 'AuthorSubscriptionPlan';
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  monthly?: Maybe<AuthorSubscriptionPlanPrice>;
  name: Scalars['String']['output'];
  platformCommissionMonthly: Scalars['Int']['output'];
  platformCommissionYearly: Scalars['Int']['output'];
  yearly?: Maybe<AuthorSubscriptionPlanPrice>;
};

export enum AuthorSubscriptionPlanFrequency {
  Monthly = 'monthly',
  Yearly = 'yearly',
}

export type AuthorSubscriptionPlanPrice = {
  __typename?: 'AuthorSubscriptionPlanPrice';
  priceInCents: Scalars['Int']['output'];
  stripePlanId: Scalars['String']['output'];
};

export type AuthorSubscriptionPromocode = {
  __typename?: 'AuthorSubscriptionPromocode';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Balance = {
  __typename?: 'Balance';
  available: Array<BalanceAmount>;
  pending: Array<BalanceAmount>;
};

export type BalanceAmount = {
  __typename?: 'BalanceAmount';
  amount: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
}

export type CompletePageResult = {
  __typename?: 'CompletePageResult';
  courseCompleted?: Maybe<Scalars['Boolean']['output']>;
  pageCompleted?: Maybe<Scalars['Boolean']['output']>;
};

export type ConnectStripe = {
  __typename?: 'ConnectStripe';
  redirectUrl: Scalars['String']['output'];
};

export type ContinueStripeOnboarding = {
  __typename?: 'ContinueStripeOnboarding';
  redirectUrl: Scalars['String']['output'];
};

export type CustomVideo = {
  __typename?: 'CustomVideo';
  createdAt?: Maybe<Scalars['String']['output']>;
  guid: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status: CustomVideoStatus;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  transcodingProgress?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum CustomVideoStatus {
  Error = 'error',
  Pending = 'pending',
  Ready = 'ready',
  Transcoding = 'transcoding',
  Uploading = 'uploading',
}

export type GettingStarted = {
  __typename?: 'GettingStarted';
  hasContentAdded?: Maybe<Scalars['Boolean']['output']>;
  hasLaunchPageUpdated?: Maybe<Scalars['Boolean']['output']>;
  hasProductCreated?: Maybe<Scalars['Boolean']['output']>;
  hasProductPublished?: Maybe<Scalars['Boolean']['output']>;
  hasTiersUpdated?: Maybe<Scalars['Boolean']['output']>;
};

export type GoToStripeCustomerPortal = {
  __typename?: 'GoToStripeCustomerPortal';
  redirectUrl: Scalars['String']['output'];
};

export type GoToStripeDashboard = {
  __typename?: 'GoToStripeDashboard';
  redirectUrl: Scalars['String']['output'];
};

export type Landing = {
  __typename?: 'Landing';
  content?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  media?: Maybe<LandingMedia>;
  subtitle?: Maybe<Scalars['String']['output']>;
  tiersHeader?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type LandingMedia = {
  __typename?: 'LandingMedia';
  coverUrl?: Maybe<Scalars['String']['output']>;
  isFullSize: Scalars['Boolean']['output'];
  provider: Scalars['String']['output'];
  src: Scalars['String']['output'];
  status?: Maybe<CustomVideoStatus>;
  type: LandingMediaType;
  videoId?: Maybe<Scalars['ID']['output']>;
};

export enum LandingMediaType {
  Embed = 'embed',
  Image = 'image',
  Video = 'video',
}

export type LoginContextInput = {
  authorId?: InputMaybe<Scalars['ID']['input']>;
  pageId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addPage?: Maybe<Page>;
  approveEmailOwnershipWithCode?: Maybe<Scalars['Boolean']['output']>;
  archivePage?: Maybe<Scalars['Boolean']['output']>;
  archiveProduct?: Maybe<Scalars['Boolean']['output']>;
  archiveProductFolder?: Maybe<Scalars['Boolean']['output']>;
  archiveTier?: Maybe<Scalars['Boolean']['output']>;
  becomeAnAuthor?: Maybe<User>;
  cancelScheduledPagePublish?: Maybe<Scalars['Boolean']['output']>;
  cancelScheduledProductPublish?: Maybe<Scalars['Boolean']['output']>;
  completePage?: Maybe<CompletePageResult>;
  confirmEmailChange?: Maybe<User>;
  connectStripe?: Maybe<ConnectStripe>;
  continueStripeOnboarding?: Maybe<ContinueStripeOnboarding>;
  createProduct?: Maybe<Product>;
  createProductFolder?: Maybe<ProductFolder>;
  downgradeAuthorSubscription?: Maybe<Scalars['Boolean']['output']>;
  duplicateProduct?: Maybe<Product>;
  goToStripeCustomerPortal?: Maybe<GoToStripeCustomerPortal>;
  goToStripeDashboard?: Maybe<GoToStripeDashboard>;
  logOut?: Maybe<Scalars['Boolean']['output']>;
  loginWithEmailCode?: Maybe<Scalars['Boolean']['output']>;
  loginWithGoogle?: Maybe<UserSession>;
  publishPage?: Maybe<Scalars['Boolean']['output']>;
  publishProduct?: Maybe<Scalars['Boolean']['output']>;
  purchase?: Maybe<PaymentIntent>;
  purchaseForFreeTier?: Maybe<PaymentIntent>;
  purchaseForFreeTierWithGoogle?: Maybe<PaymentIntent>;
  purchaseUpgrade?: Maybe<PaymentIntent>;
  readNewPublishedPage?: Maybe<Scalars['Boolean']['output']>;
  schedulePagePublish?: Maybe<Scalars['Boolean']['output']>;
  scheduleProductPublish?: Maybe<Scalars['Boolean']['output']>;
  triggerPageContentChanged?: Maybe<Page>;
  unpublishPage?: Maybe<Scalars['Boolean']['output']>;
  unpublishProduct?: Maybe<Scalars['Boolean']['output']>;
  updateCustomVideo?: Maybe<CustomVideo>;
  updateLanding?: Maybe<Landing>;
  updatePage?: Maybe<Page>;
  updateProduct?: Maybe<Product>;
  updateTiers?: Maybe<Array<Tier>>;
  updateUser?: Maybe<User>;
  updateUserSettings?: Maybe<UserSettings>;
  upgradeAuthorSubscription?: Maybe<UpgradeAuthorSubscription>;
  uploadNewVideo?: Maybe<UploadNewVideo>;
  verifyEmailCode?: Maybe<UserSession>;
};

export type MutationAddPageArgs = {
  input: AddPageInput;
};

export type MutationApproveEmailOwnershipWithCodeArgs = {
  email: Scalars['String']['input'];
};

export type MutationArchivePageArgs = {
  id: Scalars['ID']['input'];
};

export type MutationArchiveProductArgs = {
  id: Scalars['ID']['input'];
};

export type MutationArchiveProductFolderArgs = {
  id: Scalars['ID']['input'];
};

export type MutationArchiveTierArgs = {
  input: ArchiveTierInput;
};

export type MutationCancelScheduledPagePublishArgs = {
  id: Scalars['ID']['input'];
};

export type MutationCancelScheduledProductPublishArgs = {
  id: Scalars['ID']['input'];
};

export type MutationCompletePageArgs = {
  id: Scalars['ID']['input'];
};

export type MutationConfirmEmailChangeArgs = {
  code: Scalars['String']['input'];
};

export type MutationConnectStripeArgs = {
  input: ConnectStripeInput;
};

export type MutationContinueStripeOnboardingArgs = {
  input: ContinueStripeOnboardingInput;
};

export type MutationCreateProductArgs = {
  input: CreateProductInput;
};

export type MutationCreateProductFolderArgs = {
  input: CreateProductFolderInput;
};

export type MutationDuplicateProductArgs = {
  input: DuplicateProductInput;
};

export type MutationGoToStripeCustomerPortalArgs = {
  input: GoToStripeCustomerPortalInput;
};

export type MutationLoginWithEmailCodeArgs = {
  input: LoginWithEmailCodeInput;
};

export type MutationLoginWithGoogleArgs = {
  input: LoginWithGoogleInput;
};

export type MutationPublishPageArgs = {
  id: Scalars['ID']['input'];
};

export type MutationPublishProductArgs = {
  input: PublishProductInput;
};

export type MutationPurchaseArgs = {
  input: PurchaseInput;
};

export type MutationPurchaseForFreeTierArgs = {
  input: PurchaseInput;
};

export type MutationPurchaseForFreeTierWithGoogleArgs = {
  input: PurchaseInput;
};

export type MutationPurchaseUpgradeArgs = {
  input: PurchaseInput;
};

export type MutationReadNewPublishedPageArgs = {
  id: Scalars['ID']['input'];
};

export type MutationSchedulePagePublishArgs = {
  input: SchedulePagePublishInput;
};

export type MutationScheduleProductPublishArgs = {
  input: ScheduleProductPublishInput;
};

export type MutationTriggerPageContentChangedArgs = {
  id: Scalars['ID']['input'];
};

export type MutationUnpublishPageArgs = {
  id: Scalars['ID']['input'];
};

export type MutationUnpublishProductArgs = {
  id: Scalars['ID']['input'];
};

export type MutationUpdateCustomVideoArgs = {
  input: UpdateCustomVideoInput;
};

export type MutationUpdateLandingArgs = {
  input: UpdateLandingInput;
};

export type MutationUpdatePageArgs = {
  input: UpdatePageInput;
};

export type MutationUpdateProductArgs = {
  input: UpdateProductInput;
};

export type MutationUpdateTiersArgs = {
  input: UpdateTiersInput;
};

export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

export type MutationUpdateUserSettingsArgs = {
  input: UpdateUserSettingsInput;
};

export type MutationUpgradeAuthorSubscriptionArgs = {
  input: UpgradeAuthorSubscriptionInput;
};

export type MutationUploadNewVideoArgs = {
  input: UploadNewVideoInput;
};

export type MutationVerifyEmailCodeArgs = {
  input: VerifyEmailCodeInput;
};

export type Notification = {
  __typename?: 'Notification';
  amountCurrency: Scalars['String']['output'];
  amountInCents: Scalars['Int']['output'];
  customer: User;
  hasSeen?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  paidAt: Scalars['String']['output'];
  product: Product;
};

export type Page = {
  __typename?: 'Page';
  content?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hasChanges?: Maybe<Scalars['Boolean']['output']>;
  hasPaidTier?: Maybe<Scalars['Boolean']['output']>;
  hasPublicTier?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCompleted?: Maybe<Scalars['Boolean']['output']>;
  isMyPage?: Maybe<Scalars['Boolean']['output']>;
  isPageNewToRead?: Maybe<Scalars['Boolean']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  isPurchased?: Maybe<Scalars['Boolean']['output']>;
  isScheduledPublishWithNotification?: Maybe<Scalars['Boolean']['output']>;
  orderNumber: Scalars['Int']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['String']['output']>;
  scheduledPublishAt?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  userHasAccess?: Maybe<Scalars['Boolean']['output']>;
};

export enum PageAccess {
  OnlyWhoPay = 'onlyWhoPay',
  Public = 'public',
}

export type PageInTier = {
  __typename?: 'PageInTier';
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  isIncluded: Scalars['Boolean']['output'];
  orderNumber: Scalars['Int']['output'];
  pageId: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type PaymentIntent = {
  __typename?: 'PaymentIntent';
  checkoutUrl: Scalars['String']['output'];
  isNewCustomer: Scalars['Boolean']['output'];
  session: Session;
  user: User;
  wasAuthorized: Scalars['Boolean']['output'];
};

export type Product = {
  __typename?: 'Product';
  author?: Maybe<User>;
  chatWidget?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hasChanges?: Maybe<Scalars['Boolean']['output']>;
  hasLandingBeenUpdated?: Maybe<Scalars['Boolean']['output']>;
  hasPaidTier?: Maybe<Scalars['Boolean']['output']>;
  hasPublicTier?: Maybe<Scalars['Boolean']['output']>;
  hasTiersBeenUpdated?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isMyProduct?: Maybe<Scalars['Boolean']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  isPurchased?: Maybe<Scalars['Boolean']['output']>;
  isScheduledPublishWithNotification?: Maybe<Scalars['Boolean']['output']>;
  lastEditAt?: Maybe<Scalars['String']['output']>;
  lowestPriceCurrency?: Maybe<Scalars['String']['output']>;
  lowestPriceId?: Maybe<Scalars['ID']['output']>;
  lowestPriceInCents?: Maybe<Scalars['Int']['output']>;
  mainCurrency?: Maybe<Scalars['String']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  productFolder?: Maybe<ProductFolder>;
  publishedAt?: Maybe<Scalars['String']['output']>;
  scheduledPublishAt?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  tierCount?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  userHasAccess?: Maybe<Scalars['Boolean']['output']>;
};

export enum ProductAccess {
  OnlyWhoPay = 'onlyWhoPay',
  OnlyWhoTip = 'onlyWhoTip',
  Public = 'public',
}

export type ProductFolder = {
  __typename?: 'ProductFolder';
  id?: Maybe<Scalars['ID']['output']>;
  slugName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ProductStats = {
  __typename?: 'ProductStats';
  productId: Scalars['ID']['output'];
  stats?: Maybe<StatsRow>;
};

export type ProductTemplate = {
  __typename?: 'ProductTemplate';
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Promocode = {
  __typename?: 'Promocode';
  code: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Purchase = {
  __typename?: 'Purchase';
  amountCurrency?: Maybe<Scalars['String']['output']>;
  amountInCents?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  product: Product;
  purchasedAt?: Maybe<Scalars['String']['output']>;
  tier: Tier;
};

export type Query = {
  __typename?: 'Query';
  getAudience?: Maybe<Array<Audient>>;
  getAuthorSubscriptionPlans?: Maybe<Array<AuthorSubscriptionPlan>>;
  getCurrentBalance?: Maybe<Balance>;
  getCustomVideo?: Maybe<CustomVideo>;
  getInviteByCode?: Maybe<AuthInvite>;
  getLanding?: Maybe<Landing>;
  getPage?: Maybe<Page>;
  getPages?: Maybe<Array<Page>>;
  getProduct?: Maybe<Product>;
  getProductFolders?: Maybe<Array<ProductFolder>>;
  getProductTemplates?: Maybe<Array<ProductTemplate>>;
  getProducts?: Maybe<Array<Product>>;
  getProductsStats?: Maybe<Array<Maybe<ProductStats>>>;
  getPublishedFreeTier?: Maybe<Tier>;
  getPublishedLanding?: Maybe<Landing>;
  getPublishedPage?: Maybe<Page>;
  getPublishedPages?: Maybe<Array<Page>>;
  getPublishedProduct?: Maybe<Product>;
  getPublishedProducts?: Maybe<Array<Product>>;
  getPublishedTiers?: Maybe<Array<Tier>>;
  getPurchasedProducts?: Maybe<Array<Purchase>>;
  getScheduledItems?: Maybe<Array<ScheduledItem>>;
  getTierStats?: Maybe<Array<Maybe<TierStats>>>;
  getTiers?: Maybe<Array<Tier>>;
  getTotalStats?: Maybe<StatsRow>;
  getUser?: Maybe<User>;
  getUserSettings?: Maybe<UserSettings>;
  isAuthorSubscriptionPromocodeAvailable?: Maybe<Scalars['Boolean']['output']>;
  isEmailBusy: Scalars['Boolean']['output'];
  isUsernameBusy: Scalars['Boolean']['output'];
  ping?: Maybe<UserSession>;
};

export type QueryGetAudienceArgs = {
  productId: Scalars['ID']['input'];
};

export type QueryGetCustomVideoArgs = {
  guid: Scalars['ID']['input'];
};

export type QueryGetInviteByCodeArgs = {
  code: Scalars['String']['input'];
};

export type QueryGetLandingArgs = {
  productId: Scalars['ID']['input'];
};

export type QueryGetPageArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetPagesArgs = {
  productId: Scalars['ID']['input'];
};

export type QueryGetProductArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetProductFoldersArgs = {
  userId: Scalars['ID']['input'];
};

export type QueryGetProductsArgs = {
  filter?: InputMaybe<GetProductsFilter>;
  username: Scalars['String']['input'];
};

export type QueryGetProductsStatsArgs = {
  productId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetPublishedFreeTierArgs = {
  productId: Scalars['ID']['input'];
};

export type QueryGetPublishedLandingArgs = {
  productId: Scalars['ID']['input'];
};

export type QueryGetPublishedPageArgs = {
  id: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};

export type QueryGetPublishedPagesArgs = {
  productId: Scalars['ID']['input'];
};

export type QueryGetPublishedProductArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetPublishedProductsArgs = {
  filter?: InputMaybe<GetPublishedProductsFilter>;
  username: Scalars['String']['input'];
};

export type QueryGetPublishedTiersArgs = {
  productId: Scalars['ID']['input'];
  promocode?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetTierStatsArgs = {
  productId: Scalars['ID']['input'];
};

export type QueryGetTiersArgs = {
  productId: Scalars['ID']['input'];
  promocode?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetUserArgs = {
  username: Scalars['String']['input'];
};

export type QueryIsAuthorSubscriptionPromocodeAvailableArgs = {
  code: Scalars['ID']['input'];
};

export type QueryIsEmailBusyArgs = {
  email: Scalars['String']['input'];
};

export type QueryIsUsernameBusyArgs = {
  username: Scalars['String']['input'];
};

export type ScheduledItem = {
  __typename?: 'ScheduledItem';
  id: Scalars['ID']['output'];
  isScheduledPublishWithNotification?: Maybe<Scalars['Boolean']['output']>;
  scheduledPublishAt?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ScheduledItemType>;
};

export enum ScheduledItemType {
  Page = 'page',
  Product = 'product',
}

export type Session = {
  __typename?: 'Session';
  expiresAt?: Maybe<Scalars['String']['output']>;
  returnPath?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
};

export type SocialLink = {
  __typename?: 'SocialLink';
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type StatsRow = {
  __typename?: 'StatsRow';
  chapterCompletions?: Maybe<Scalars['Int']['output']>;
  chapterTotal?: Maybe<Scalars['Int']['output']>;
  courseCompletions?: Maybe<Scalars['Int']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  revenue?: Maybe<Scalars['Int']['output']>;
  sales?: Maybe<Scalars['Int']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

export enum StripeAccountStatus {
  Active = 'active',
  InProgress = 'inProgress',
  Inactive = 'inactive',
  Pending = 'pending',
}

export type Subscription = {
  __typename?: 'Subscription';
  gettingStartedUpdated?: Maybe<GettingStarted>;
  pageContentChanged?: Maybe<Page>;
};

export type SubscriptionGettingStartedUpdatedArgs = {
  userId: Scalars['ID']['input'];
};

export type SubscriptionPageContentChangedArgs = {
  pageId: Scalars['ID']['input'];
};

export type Tier = {
  __typename?: 'Tier';
  access?: Maybe<ProductAccess>;
  appliedPromocode?: Maybe<AppliedPromocode>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  orderNumber: Scalars['Int']['output'];
  pageCount?: Maybe<Scalars['Int']['output']>;
  pages?: Maybe<Array<PageInTier>>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  priceInCents?: Maybe<Scalars['Int']['output']>;
  slugName?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type TierStats = {
  __typename?: 'TierStats';
  stats?: Maybe<StatsRow>;
  tierId: Scalars['ID']['output'];
};

export type UpgradeAuthorSubscription = {
  __typename?: 'UpgradeAuthorSubscription';
  checkoutUrl: Scalars['String']['output'];
};

export type UploadNewVideo = {
  __typename?: 'UploadNewVideo';
  headers?: Maybe<Scalars['JSON']['output']>;
};

export type User = {
  __typename?: 'User';
  accessExperimentalFeatures?: Maybe<Scalars['Boolean']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  gettingStarted?: Maybe<GettingStarted>;
  hasPassword?: Maybe<Scalars['Boolean']['output']>;
  hasVisitedGuide?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  invite?: Maybe<AuthInvite>;
  isDisplayNameSet?: Maybe<Scalars['Boolean']['output']>;
  isEmailApproved?: Maybe<Scalars['Boolean']['output']>;
  isMe?: Maybe<Scalars['Boolean']['output']>;
  isPartner?: Maybe<Scalars['Boolean']['output']>;
  isUsernameSet?: Maybe<Scalars['Boolean']['output']>;
  isWaitListFormSubmitted?: Maybe<Scalars['Boolean']['output']>;
  lastSentEmailVerificationAt?: Maybe<Scalars['String']['output']>;
  mainCurrency?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onboarding?: Maybe<UserOnboarding>;
  plan?: Maybe<AuthorSubscription>;
  role: UserRole;
  seoPictureUrl?: Maybe<Scalars['String']['output']>;
  socialLinks?: Maybe<Array<SocialLink>>;
  status?: Maybe<UserStatus>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  userType?: Maybe<UserType>;
  username: Scalars['String']['output'];
};

export type UserOnboarding = {
  __typename?: 'UserOnboarding';
  isDisplayNameSet?: Maybe<Scalars['Boolean']['output']>;
  isEmailApproveSet?: Maybe<Scalars['Boolean']['output']>;
  isUsernameSet?: Maybe<Scalars['Boolean']['output']>;
};

export enum UserRole {
  Author = 'author',
  Reader = 'reader',
}

export type UserSession = {
  __typename?: 'UserSession';
  isNewCustomer?: Maybe<Scalars['Boolean']['output']>;
  session?: Maybe<Session>;
  user?: Maybe<User>;
};

export type UserSettings = {
  __typename?: 'UserSettings';
  acceptingPayments?: Maybe<Scalars['Boolean']['output']>;
  acceptingPaymentsStartedAt?: Maybe<Scalars['String']['output']>;
  payoutsEnabled?: Maybe<Scalars['Boolean']['output']>;
  payoutsEnabledStartedAt?: Maybe<Scalars['String']['output']>;
  stripeAccountStatus?: Maybe<StripeAccountStatus>;
  stripeAccountStatusDescription?: Maybe<Scalars['String']['output']>;
  stripeVerifiedAt?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export enum UserStatus {
  Active = 'ACTIVE',
  AtRisk = 'AT_RISK',
  Churned = 'CHURNED',
  Deactivated = 'DEACTIVATED',
  Dormant = 'DORMANT',
  Inactive = 'INACTIVE',
  Lead = 'LEAD',
  Reactivated = 'REACTIVATED',
  Waitlist = 'WAITLIST',
}

export enum UserType {
  Admin = 'ADMIN',
  BetaTester = 'BETA_TESTER',
  CreatorActive = 'CREATOR_ACTIVE',
  CreatorInactive = 'CREATOR_INACTIVE',
  CreatorPotential = 'CREATOR_POTENTIAL',
  FoundingMember = 'FOUNDING_MEMBER',
}

export type AddPageInput = {
  content?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveTierInput = {
  id: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};

export type ConnectStripeInput = {
  countryCode: Scalars['String']['input'];
  returnPath?: InputMaybe<Scalars['String']['input']>;
};

export type ContinueStripeOnboardingInput = {
  returnPath?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProductFolderInput = {
  title: Scalars['String']['input'];
};

export type CreateProductInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  pictureUrl?: InputMaybe<Scalars['String']['input']>;
  productFolderId?: InputMaybe<Scalars['ID']['input']>;
  productTemplateId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DuplicateProductInput = {
  productId: Scalars['ID']['input'];
};

export type GetProductsFilter = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  productFolderId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetPublishedProductsFilter = {
  productFolderId?: InputMaybe<Scalars['ID']['input']>;
};

export type GoToStripeCustomerPortalInput = {
  returnPath?: InputMaybe<Scalars['String']['input']>;
};

export type LoginWithEmailCodeInput = {
  email: Scalars['String']['input'];
  inviteCode?: InputMaybe<Scalars['String']['input']>;
  loginContext?: InputMaybe<LoginContextInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  userRole: UserRole;
};

export type LoginWithGoogleInput = {
  accessToken: Scalars['String']['input'];
  inviteCode?: InputMaybe<Scalars['String']['input']>;
  loginContext?: InputMaybe<LoginContextInput>;
  userRole: UserRole;
};

export type PageInTierInput = {
  isIncluded: Scalars['Boolean']['input'];
  pageId: Scalars['ID']['input'];
};

export type PublishProductInput = {
  id: Scalars['ID']['input'];
};

export type PurchaseCustomerInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type PurchaseInput = {
  customer?: InputMaybe<PurchaseCustomerInput>;
  pageId?: InputMaybe<Scalars['ID']['input']>;
  productId: Scalars['ID']['input'];
  promocode?: InputMaybe<Scalars['String']['input']>;
  tierId: Scalars['ID']['input'];
};

export type SchedulePagePublishInput = {
  id: Scalars['ID']['input'];
  isScheduledPublishWithNotification: Scalars['Boolean']['input'];
  scheduledPublishAt: Scalars['String']['input'];
};

export type ScheduleProductPublishInput = {
  id: Scalars['ID']['input'];
  isScheduledPublishWithNotification: Scalars['Boolean']['input'];
  scheduledPublishAt: Scalars['String']['input'];
};

export type TierInput = {
  access?: InputMaybe<ProductAccess>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pages?: InputMaybe<Array<PageInTierInput>>;
  pictureUrl?: InputMaybe<Scalars['String']['input']>;
  priceInCents?: InputMaybe<Scalars['Int']['input']>;
  slugName?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomVideoInput = {
  guid: Scalars['ID']['input'];
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLandingInput = {
  content?: InputMaybe<Scalars['JSON']['input']>;
  media?: InputMaybe<UpdateLandingMediaInput>;
  productId: Scalars['String']['input'];
  subtitle?: InputMaybe<Scalars['String']['input']>;
  tiersHeader?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLandingMediaInput = {
  coverUrl?: InputMaybe<Scalars['String']['input']>;
  isFullSize: Scalars['Boolean']['input'];
  provider: Scalars['String']['input'];
  src: Scalars['String']['input'];
  type: LandingMediaType;
  videoId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePageInput = {
  content?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  pictureUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePageOrderInput = {
  orderNumber: Scalars['Int']['input'];
  pageId: Scalars['ID']['input'];
};

export type UpdatePageSettingsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  pictureUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  pictureUrl?: InputMaybe<Scalars['String']['input']>;
  productFolderId?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTiersInput = {
  productId: Scalars['ID']['input'];
  tiers: Array<TierInput>;
};

export type UpdateUserInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  hasVisitedGuide?: InputMaybe<Scalars['Boolean']['input']>;
  mainCurrency?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  seoPictureUrl?: InputMaybe<Scalars['String']['input']>;
  socialLinks?: InputMaybe<Array<UpdateUserInputSocialLink>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInputSocialLink = {
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type UpdateUserSettingsInput = {
  acceptingPayments?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpgradeAuthorSubscriptionInput = {
  cancelReturnPath: Scalars['String']['input'];
  successReturnPath: Scalars['String']['input'];
};

export type UploadNewVideoInput = {
  productId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type VerifyEmailCodeInput = {
  email: Scalars['String']['input'];
  signInCode: Scalars['String']['input'];
};

export type BecomeAnAuthorMutationVariables = Exact<{ [key: string]: never }>;

export type BecomeAnAuthorMutation = {
  __typename?: 'Mutation';
  becomeAnAuthor?: {
    __typename?: 'User';
    id: string;
    isMe?: boolean | null;
    email?: string | null;
    username: string;
    name?: string | null;
    url: string;
    role: UserRole;
    bio?: string | null;
    avatarUrl?: string | null;
    seoPictureUrl?: string | null;
    mainCurrency?: string | null;
    isPartner?: boolean | null;
    accessExperimentalFeatures?: boolean | null;
    hasVisitedGuide?: boolean | null;
    status?: UserStatus | null;
    userType?: UserType | null;
    isEmailApproved?: boolean | null;
    hasPassword?: boolean | null;
    isWaitListFormSubmitted?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    lastSentEmailVerificationAt?: string | null;
    socialLinks?: Array<{ __typename?: 'SocialLink'; type: string; url: string }> | null;
    plan?: {
      __typename?: 'AuthorSubscription';
      id: string;
      name: string;
      frequency?: AuthorSubscriptionPlanFrequency | null;
      activatedAt?: string | null;
      expiresAt?: string | null;
      nextPaymentAt?: string | null;
      hasPromocodeApplied?: boolean | null;
    } | null;
    gettingStarted?: {
      __typename?: 'GettingStarted';
      hasProductCreated?: boolean | null;
      hasContentAdded?: boolean | null;
      hasTiersUpdated?: boolean | null;
      hasLaunchPageUpdated?: boolean | null;
      hasProductPublished?: boolean | null;
    } | null;
    invite?: {
      __typename?: 'AuthInvite';
      id: string;
      code: string;
      owner: { __typename?: 'AuthInviteOwner'; id: string; name: string; username: string };
      promocode?: {
        __typename?: 'AuthorSubscriptionPromocode';
        id: string;
        name: string;
        code: string;
      } | null;
    } | null;
    onboarding?: {
      __typename?: 'UserOnboarding';
      isDisplayNameSet?: boolean | null;
      isUsernameSet?: boolean | null;
      isEmailApproveSet?: boolean | null;
    } | null;
  } | null;
};

export type ConnectStripeMutationVariables = Exact<{
  input: ConnectStripeInput;
}>;

export type ConnectStripeMutation = {
  __typename?: 'Mutation';
  connectStripe?: { __typename?: 'ConnectStripe'; redirectUrl: string } | null;
};

export type ContinueStripeOnboardingMutationVariables = Exact<{
  input: ContinueStripeOnboardingInput;
}>;

export type ContinueStripeOnboardingMutation = {
  __typename?: 'Mutation';
  continueStripeOnboarding?: {
    __typename?: 'ContinueStripeOnboarding';
    redirectUrl: string;
  } | null;
};

export type DowngradeAuthorSubscriptionMutationVariables = Exact<{ [key: string]: never }>;

export type DowngradeAuthorSubscriptionMutation = {
  __typename?: 'Mutation';
  downgradeAuthorSubscription?: boolean | null;
};

export type AuthorSubscriptionFragmentFragment = {
  __typename?: 'AuthorSubscription';
  id: string;
  name: string;
  frequency?: AuthorSubscriptionPlanFrequency | null;
  activatedAt?: string | null;
  expiresAt?: string | null;
  nextPaymentAt?: string | null;
  hasPromocodeApplied?: boolean | null;
};

export type UserFragmentFragment = {
  __typename?: 'User';
  id: string;
  isMe?: boolean | null;
  email?: string | null;
  username: string;
  name?: string | null;
  url: string;
  role: UserRole;
  bio?: string | null;
  avatarUrl?: string | null;
  seoPictureUrl?: string | null;
  mainCurrency?: string | null;
  isPartner?: boolean | null;
  accessExperimentalFeatures?: boolean | null;
  hasVisitedGuide?: boolean | null;
  status?: UserStatus | null;
  userType?: UserType | null;
  isEmailApproved?: boolean | null;
  hasPassword?: boolean | null;
  isWaitListFormSubmitted?: boolean | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  lastSentEmailVerificationAt?: string | null;
  socialLinks?: Array<{ __typename?: 'SocialLink'; type: string; url: string }> | null;
  plan?: {
    __typename?: 'AuthorSubscription';
    id: string;
    name: string;
    frequency?: AuthorSubscriptionPlanFrequency | null;
    activatedAt?: string | null;
    expiresAt?: string | null;
    nextPaymentAt?: string | null;
    hasPromocodeApplied?: boolean | null;
  } | null;
  gettingStarted?: {
    __typename?: 'GettingStarted';
    hasProductCreated?: boolean | null;
    hasContentAdded?: boolean | null;
    hasTiersUpdated?: boolean | null;
    hasLaunchPageUpdated?: boolean | null;
    hasProductPublished?: boolean | null;
  } | null;
  invite?: {
    __typename?: 'AuthInvite';
    id: string;
    code: string;
    owner: { __typename?: 'AuthInviteOwner'; id: string; name: string; username: string };
    promocode?: {
      __typename?: 'AuthorSubscriptionPromocode';
      id: string;
      name: string;
      code: string;
    } | null;
  } | null;
  onboarding?: {
    __typename?: 'UserOnboarding';
    isDisplayNameSet?: boolean | null;
    isUsernameSet?: boolean | null;
    isEmailApproveSet?: boolean | null;
  } | null;
};

export type UserSessionFragmentFragment = {
  __typename?: 'UserSession';
  isNewCustomer?: boolean | null;
  session?: { __typename?: 'Session'; token: string; expiresAt?: string | null } | null;
  user?: {
    __typename?: 'User';
    id: string;
    isMe?: boolean | null;
    email?: string | null;
    username: string;
    name?: string | null;
    url: string;
    role: UserRole;
    bio?: string | null;
    avatarUrl?: string | null;
    seoPictureUrl?: string | null;
    mainCurrency?: string | null;
    isPartner?: boolean | null;
    accessExperimentalFeatures?: boolean | null;
    hasVisitedGuide?: boolean | null;
    status?: UserStatus | null;
    userType?: UserType | null;
    isEmailApproved?: boolean | null;
    hasPassword?: boolean | null;
    isWaitListFormSubmitted?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    lastSentEmailVerificationAt?: string | null;
    socialLinks?: Array<{ __typename?: 'SocialLink'; type: string; url: string }> | null;
    plan?: {
      __typename?: 'AuthorSubscription';
      id: string;
      name: string;
      frequency?: AuthorSubscriptionPlanFrequency | null;
      activatedAt?: string | null;
      expiresAt?: string | null;
      nextPaymentAt?: string | null;
      hasPromocodeApplied?: boolean | null;
    } | null;
    gettingStarted?: {
      __typename?: 'GettingStarted';
      hasProductCreated?: boolean | null;
      hasContentAdded?: boolean | null;
      hasTiersUpdated?: boolean | null;
      hasLaunchPageUpdated?: boolean | null;
      hasProductPublished?: boolean | null;
    } | null;
    invite?: {
      __typename?: 'AuthInvite';
      id: string;
      code: string;
      owner: { __typename?: 'AuthInviteOwner'; id: string; name: string; username: string };
      promocode?: {
        __typename?: 'AuthorSubscriptionPromocode';
        id: string;
        name: string;
        code: string;
      } | null;
    } | null;
    onboarding?: {
      __typename?: 'UserOnboarding';
      isDisplayNameSet?: boolean | null;
      isUsernameSet?: boolean | null;
      isEmailApproveSet?: boolean | null;
    } | null;
  } | null;
};

export type GetInviteByCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;

export type GetInviteByCodeQuery = {
  __typename?: 'Query';
  getInviteByCode?: {
    __typename?: 'AuthInvite';
    id: string;
    code: string;
    owner: { __typename?: 'AuthInviteOwner'; id: string; name: string; username: string };
  } | null;
};

export type GoToStripeDashboardMutationVariables = Exact<{ [key: string]: never }>;

export type GoToStripeDashboardMutation = {
  __typename?: 'Mutation';
  goToStripeDashboard?: { __typename?: 'GoToStripeDashboard'; redirectUrl: string } | null;
};

export type LogOutMutationVariables = Exact<{ [key: string]: never }>;

export type LogOutMutation = { __typename?: 'Mutation'; logOut?: boolean | null };

export type LoginWithEmailCodeMutationVariables = Exact<{
  input: LoginWithEmailCodeInput;
}>;

export type LoginWithEmailCodeMutation = {
  __typename?: 'Mutation';
  loginWithEmailCode?: boolean | null;
};

export type LoginWithGoogleMutationVariables = Exact<{
  input: LoginWithGoogleInput;
}>;

export type LoginWithGoogleMutation = {
  __typename?: 'Mutation';
  loginWithGoogle?: {
    __typename?: 'UserSession';
    isNewCustomer?: boolean | null;
    session?: { __typename?: 'Session'; token: string; expiresAt?: string | null } | null;
    user?: {
      __typename?: 'User';
      id: string;
      isMe?: boolean | null;
      email?: string | null;
      username: string;
      name?: string | null;
      url: string;
      role: UserRole;
      bio?: string | null;
      avatarUrl?: string | null;
      seoPictureUrl?: string | null;
      mainCurrency?: string | null;
      isPartner?: boolean | null;
      accessExperimentalFeatures?: boolean | null;
      hasVisitedGuide?: boolean | null;
      status?: UserStatus | null;
      userType?: UserType | null;
      isEmailApproved?: boolean | null;
      hasPassword?: boolean | null;
      isWaitListFormSubmitted?: boolean | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      lastSentEmailVerificationAt?: string | null;
      socialLinks?: Array<{ __typename?: 'SocialLink'; type: string; url: string }> | null;
      plan?: {
        __typename?: 'AuthorSubscription';
        id: string;
        name: string;
        frequency?: AuthorSubscriptionPlanFrequency | null;
        activatedAt?: string | null;
        expiresAt?: string | null;
        nextPaymentAt?: string | null;
        hasPromocodeApplied?: boolean | null;
      } | null;
      gettingStarted?: {
        __typename?: 'GettingStarted';
        hasProductCreated?: boolean | null;
        hasContentAdded?: boolean | null;
        hasTiersUpdated?: boolean | null;
        hasLaunchPageUpdated?: boolean | null;
        hasProductPublished?: boolean | null;
      } | null;
      invite?: {
        __typename?: 'AuthInvite';
        id: string;
        code: string;
        owner: { __typename?: 'AuthInviteOwner'; id: string; name: string; username: string };
        promocode?: {
          __typename?: 'AuthorSubscriptionPromocode';
          id: string;
          name: string;
          code: string;
        } | null;
      } | null;
      onboarding?: {
        __typename?: 'UserOnboarding';
        isDisplayNameSet?: boolean | null;
        isUsernameSet?: boolean | null;
        isEmailApproveSet?: boolean | null;
      } | null;
    } | null;
  } | null;
};

export type PingQueryVariables = Exact<{ [key: string]: never }>;

export type PingQuery = {
  __typename?: 'Query';
  ping?: {
    __typename?: 'UserSession';
    session?: { __typename?: 'Session'; token: string; expiresAt?: string | null } | null;
    user?: {
      __typename?: 'User';
      id: string;
      isMe?: boolean | null;
      email?: string | null;
      username: string;
      name?: string | null;
      url: string;
      role: UserRole;
      bio?: string | null;
      avatarUrl?: string | null;
      seoPictureUrl?: string | null;
      mainCurrency?: string | null;
      isPartner?: boolean | null;
      accessExperimentalFeatures?: boolean | null;
      hasVisitedGuide?: boolean | null;
      status?: UserStatus | null;
      userType?: UserType | null;
      isEmailApproved?: boolean | null;
      hasPassword?: boolean | null;
      isWaitListFormSubmitted?: boolean | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      lastSentEmailVerificationAt?: string | null;
      socialLinks?: Array<{ __typename?: 'SocialLink'; type: string; url: string }> | null;
      plan?: {
        __typename?: 'AuthorSubscription';
        id: string;
        name: string;
        frequency?: AuthorSubscriptionPlanFrequency | null;
        activatedAt?: string | null;
        expiresAt?: string | null;
        nextPaymentAt?: string | null;
        hasPromocodeApplied?: boolean | null;
      } | null;
      gettingStarted?: {
        __typename?: 'GettingStarted';
        hasProductCreated?: boolean | null;
        hasContentAdded?: boolean | null;
        hasTiersUpdated?: boolean | null;
        hasLaunchPageUpdated?: boolean | null;
        hasProductPublished?: boolean | null;
      } | null;
      invite?: {
        __typename?: 'AuthInvite';
        id: string;
        code: string;
        owner: { __typename?: 'AuthInviteOwner'; id: string; name: string; username: string };
        promocode?: {
          __typename?: 'AuthorSubscriptionPromocode';
          id: string;
          name: string;
          code: string;
        } | null;
      } | null;
      onboarding?: {
        __typename?: 'UserOnboarding';
        isDisplayNameSet?: boolean | null;
        isUsernameSet?: boolean | null;
        isEmailApproveSet?: boolean | null;
      } | null;
    } | null;
  } | null;
};

export type PurchaseProductMutationVariables = Exact<{
  input: PurchaseInput;
}>;

export type PurchaseProductMutation = {
  __typename?: 'Mutation';
  purchase?: {
    __typename?: 'PaymentIntent';
    isNewCustomer: boolean;
    wasAuthorized: boolean;
    checkoutUrl: string;
    user: {
      __typename?: 'User';
      id: string;
      isMe?: boolean | null;
      email?: string | null;
      username: string;
      name?: string | null;
      url: string;
      role: UserRole;
      bio?: string | null;
      avatarUrl?: string | null;
      seoPictureUrl?: string | null;
      mainCurrency?: string | null;
      isPartner?: boolean | null;
      accessExperimentalFeatures?: boolean | null;
      hasVisitedGuide?: boolean | null;
      status?: UserStatus | null;
      userType?: UserType | null;
      isEmailApproved?: boolean | null;
      hasPassword?: boolean | null;
      isWaitListFormSubmitted?: boolean | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      lastSentEmailVerificationAt?: string | null;
      socialLinks?: Array<{ __typename?: 'SocialLink'; type: string; url: string }> | null;
      plan?: {
        __typename?: 'AuthorSubscription';
        id: string;
        name: string;
        frequency?: AuthorSubscriptionPlanFrequency | null;
        activatedAt?: string | null;
        expiresAt?: string | null;
        nextPaymentAt?: string | null;
        hasPromocodeApplied?: boolean | null;
      } | null;
      gettingStarted?: {
        __typename?: 'GettingStarted';
        hasProductCreated?: boolean | null;
        hasContentAdded?: boolean | null;
        hasTiersUpdated?: boolean | null;
        hasLaunchPageUpdated?: boolean | null;
        hasProductPublished?: boolean | null;
      } | null;
      invite?: {
        __typename?: 'AuthInvite';
        id: string;
        code: string;
        owner: { __typename?: 'AuthInviteOwner'; id: string; name: string; username: string };
        promocode?: {
          __typename?: 'AuthorSubscriptionPromocode';
          id: string;
          name: string;
          code: string;
        } | null;
      } | null;
      onboarding?: {
        __typename?: 'UserOnboarding';
        isDisplayNameSet?: boolean | null;
        isUsernameSet?: boolean | null;
        isEmailApproveSet?: boolean | null;
      } | null;
    };
    session: { __typename?: 'Session'; token: string; expiresAt?: string | null };
  } | null;
};

export type PurchaseForFreeTierMutationVariables = Exact<{
  input: PurchaseInput;
}>;

export type PurchaseForFreeTierMutation = {
  __typename?: 'Mutation';
  purchaseForFreeTier?: {
    __typename?: 'PaymentIntent';
    isNewCustomer: boolean;
    wasAuthorized: boolean;
    checkoutUrl: string;
    user: {
      __typename?: 'User';
      id: string;
      isMe?: boolean | null;
      email?: string | null;
      username: string;
      name?: string | null;
      url: string;
      role: UserRole;
      bio?: string | null;
      avatarUrl?: string | null;
      seoPictureUrl?: string | null;
      mainCurrency?: string | null;
      isPartner?: boolean | null;
      accessExperimentalFeatures?: boolean | null;
      hasVisitedGuide?: boolean | null;
      status?: UserStatus | null;
      userType?: UserType | null;
      isEmailApproved?: boolean | null;
      hasPassword?: boolean | null;
      isWaitListFormSubmitted?: boolean | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      lastSentEmailVerificationAt?: string | null;
      socialLinks?: Array<{ __typename?: 'SocialLink'; type: string; url: string }> | null;
      plan?: {
        __typename?: 'AuthorSubscription';
        id: string;
        name: string;
        frequency?: AuthorSubscriptionPlanFrequency | null;
        activatedAt?: string | null;
        expiresAt?: string | null;
        nextPaymentAt?: string | null;
        hasPromocodeApplied?: boolean | null;
      } | null;
      gettingStarted?: {
        __typename?: 'GettingStarted';
        hasProductCreated?: boolean | null;
        hasContentAdded?: boolean | null;
        hasTiersUpdated?: boolean | null;
        hasLaunchPageUpdated?: boolean | null;
        hasProductPublished?: boolean | null;
      } | null;
      invite?: {
        __typename?: 'AuthInvite';
        id: string;
        code: string;
        owner: { __typename?: 'AuthInviteOwner'; id: string; name: string; username: string };
        promocode?: {
          __typename?: 'AuthorSubscriptionPromocode';
          id: string;
          name: string;
          code: string;
        } | null;
      } | null;
      onboarding?: {
        __typename?: 'UserOnboarding';
        isDisplayNameSet?: boolean | null;
        isUsernameSet?: boolean | null;
        isEmailApproveSet?: boolean | null;
      } | null;
    };
    session: { __typename?: 'Session'; token: string; expiresAt?: string | null };
  } | null;
};

export type PurchaseUpgradeProductMutationVariables = Exact<{
  input: PurchaseInput;
}>;

export type PurchaseUpgradeProductMutation = {
  __typename?: 'Mutation';
  purchaseUpgrade?: {
    __typename?: 'PaymentIntent';
    isNewCustomer: boolean;
    wasAuthorized: boolean;
    checkoutUrl: string;
    user: {
      __typename?: 'User';
      id: string;
      isMe?: boolean | null;
      email?: string | null;
      username: string;
      name?: string | null;
      url: string;
      role: UserRole;
      bio?: string | null;
      avatarUrl?: string | null;
      seoPictureUrl?: string | null;
      mainCurrency?: string | null;
      isPartner?: boolean | null;
      accessExperimentalFeatures?: boolean | null;
      hasVisitedGuide?: boolean | null;
      status?: UserStatus | null;
      userType?: UserType | null;
      isEmailApproved?: boolean | null;
      hasPassword?: boolean | null;
      isWaitListFormSubmitted?: boolean | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      lastSentEmailVerificationAt?: string | null;
      socialLinks?: Array<{ __typename?: 'SocialLink'; type: string; url: string }> | null;
      plan?: {
        __typename?: 'AuthorSubscription';
        id: string;
        name: string;
        frequency?: AuthorSubscriptionPlanFrequency | null;
        activatedAt?: string | null;
        expiresAt?: string | null;
        nextPaymentAt?: string | null;
        hasPromocodeApplied?: boolean | null;
      } | null;
      gettingStarted?: {
        __typename?: 'GettingStarted';
        hasProductCreated?: boolean | null;
        hasContentAdded?: boolean | null;
        hasTiersUpdated?: boolean | null;
        hasLaunchPageUpdated?: boolean | null;
        hasProductPublished?: boolean | null;
      } | null;
      invite?: {
        __typename?: 'AuthInvite';
        id: string;
        code: string;
        owner: { __typename?: 'AuthInviteOwner'; id: string; name: string; username: string };
        promocode?: {
          __typename?: 'AuthorSubscriptionPromocode';
          id: string;
          name: string;
          code: string;
        } | null;
      } | null;
      onboarding?: {
        __typename?: 'UserOnboarding';
        isDisplayNameSet?: boolean | null;
        isUsernameSet?: boolean | null;
        isEmailApproveSet?: boolean | null;
      } | null;
    };
    session: { __typename?: 'Session'; token: string; expiresAt?: string | null };
  } | null;
};

export type StripeSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type StripeSettingsQuery = {
  __typename?: 'Query';
  getUserSettings?: {
    __typename?: 'UserSettings';
    stripeAccountStatus?: StripeAccountStatus | null;
    stripeAccountStatusDescription?: string | null;
    acceptingPayments?: boolean | null;
    acceptingPaymentsStartedAt?: string | null;
    payoutsEnabled?: boolean | null;
    payoutsEnabledStartedAt?: string | null;
    stripeVerifiedAt?: string | null;
    timezone?: string | null;
  } | null;
};

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;

export type UpdateUserMutation = {
  __typename?: 'Mutation';
  updateUser?: {
    __typename?: 'User';
    id: string;
    isMe?: boolean | null;
    email?: string | null;
    username: string;
    name?: string | null;
    url: string;
    role: UserRole;
    bio?: string | null;
    avatarUrl?: string | null;
    seoPictureUrl?: string | null;
    mainCurrency?: string | null;
    isPartner?: boolean | null;
    accessExperimentalFeatures?: boolean | null;
    hasVisitedGuide?: boolean | null;
    status?: UserStatus | null;
    userType?: UserType | null;
    isEmailApproved?: boolean | null;
    hasPassword?: boolean | null;
    isWaitListFormSubmitted?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    lastSentEmailVerificationAt?: string | null;
    socialLinks?: Array<{ __typename?: 'SocialLink'; type: string; url: string }> | null;
    plan?: {
      __typename?: 'AuthorSubscription';
      id: string;
      name: string;
      frequency?: AuthorSubscriptionPlanFrequency | null;
      activatedAt?: string | null;
      expiresAt?: string | null;
      nextPaymentAt?: string | null;
      hasPromocodeApplied?: boolean | null;
    } | null;
    gettingStarted?: {
      __typename?: 'GettingStarted';
      hasProductCreated?: boolean | null;
      hasContentAdded?: boolean | null;
      hasTiersUpdated?: boolean | null;
      hasLaunchPageUpdated?: boolean | null;
      hasProductPublished?: boolean | null;
    } | null;
    invite?: {
      __typename?: 'AuthInvite';
      id: string;
      code: string;
      owner: { __typename?: 'AuthInviteOwner'; id: string; name: string; username: string };
      promocode?: {
        __typename?: 'AuthorSubscriptionPromocode';
        id: string;
        name: string;
        code: string;
      } | null;
    } | null;
    onboarding?: {
      __typename?: 'UserOnboarding';
      isDisplayNameSet?: boolean | null;
      isUsernameSet?: boolean | null;
      isEmailApproveSet?: boolean | null;
    } | null;
  } | null;
};

export type UpgradeAuthorSubscriptionMutationVariables = Exact<{
  input: UpgradeAuthorSubscriptionInput;
}>;

export type UpgradeAuthorSubscriptionMutation = {
  __typename?: 'Mutation';
  upgradeAuthorSubscription?: {
    __typename?: 'UpgradeAuthorSubscription';
    checkoutUrl: string;
  } | null;
};

export type GetUserQueryVariables = Exact<{
  username: Scalars['String']['input'];
}>;

export type GetUserQuery = {
  __typename?: 'Query';
  getUser?: {
    __typename?: 'User';
    id: string;
    isMe?: boolean | null;
    email?: string | null;
    username: string;
    name?: string | null;
    url: string;
    role: UserRole;
    bio?: string | null;
    avatarUrl?: string | null;
    seoPictureUrl?: string | null;
    mainCurrency?: string | null;
    isPartner?: boolean | null;
    accessExperimentalFeatures?: boolean | null;
    hasVisitedGuide?: boolean | null;
    status?: UserStatus | null;
    userType?: UserType | null;
    isEmailApproved?: boolean | null;
    hasPassword?: boolean | null;
    isWaitListFormSubmitted?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    lastSentEmailVerificationAt?: string | null;
    socialLinks?: Array<{ __typename?: 'SocialLink'; type: string; url: string }> | null;
    plan?: {
      __typename?: 'AuthorSubscription';
      id: string;
      name: string;
      frequency?: AuthorSubscriptionPlanFrequency | null;
      activatedAt?: string | null;
      expiresAt?: string | null;
      nextPaymentAt?: string | null;
      hasPromocodeApplied?: boolean | null;
    } | null;
    gettingStarted?: {
      __typename?: 'GettingStarted';
      hasProductCreated?: boolean | null;
      hasContentAdded?: boolean | null;
      hasTiersUpdated?: boolean | null;
      hasLaunchPageUpdated?: boolean | null;
      hasProductPublished?: boolean | null;
    } | null;
    invite?: {
      __typename?: 'AuthInvite';
      id: string;
      code: string;
      owner: { __typename?: 'AuthInviteOwner'; id: string; name: string; username: string };
      promocode?: {
        __typename?: 'AuthorSubscriptionPromocode';
        id: string;
        name: string;
        code: string;
      } | null;
    } | null;
    onboarding?: {
      __typename?: 'UserOnboarding';
      isDisplayNameSet?: boolean | null;
      isUsernameSet?: boolean | null;
      isEmailApproveSet?: boolean | null;
    } | null;
  } | null;
};

export type VerifyEmailCodeMutationVariables = Exact<{
  input: VerifyEmailCodeInput;
}>;

export type VerifyEmailCodeMutation = {
  __typename?: 'Mutation';
  verifyEmailCode?: {
    __typename?: 'UserSession';
    isNewCustomer?: boolean | null;
    session?: { __typename?: 'Session'; token: string; expiresAt?: string | null } | null;
    user?: {
      __typename?: 'User';
      id: string;
      isMe?: boolean | null;
      email?: string | null;
      username: string;
      name?: string | null;
      url: string;
      role: UserRole;
      bio?: string | null;
      avatarUrl?: string | null;
      seoPictureUrl?: string | null;
      mainCurrency?: string | null;
      isPartner?: boolean | null;
      accessExperimentalFeatures?: boolean | null;
      hasVisitedGuide?: boolean | null;
      status?: UserStatus | null;
      userType?: UserType | null;
      isEmailApproved?: boolean | null;
      hasPassword?: boolean | null;
      isWaitListFormSubmitted?: boolean | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      lastSentEmailVerificationAt?: string | null;
      socialLinks?: Array<{ __typename?: 'SocialLink'; type: string; url: string }> | null;
      plan?: {
        __typename?: 'AuthorSubscription';
        id: string;
        name: string;
        frequency?: AuthorSubscriptionPlanFrequency | null;
        activatedAt?: string | null;
        expiresAt?: string | null;
        nextPaymentAt?: string | null;
        hasPromocodeApplied?: boolean | null;
      } | null;
      gettingStarted?: {
        __typename?: 'GettingStarted';
        hasProductCreated?: boolean | null;
        hasContentAdded?: boolean | null;
        hasTiersUpdated?: boolean | null;
        hasLaunchPageUpdated?: boolean | null;
        hasProductPublished?: boolean | null;
      } | null;
      invite?: {
        __typename?: 'AuthInvite';
        id: string;
        code: string;
        owner: { __typename?: 'AuthInviteOwner'; id: string; name: string; username: string };
        promocode?: {
          __typename?: 'AuthorSubscriptionPromocode';
          id: string;
          name: string;
          code: string;
        } | null;
      } | null;
      onboarding?: {
        __typename?: 'UserOnboarding';
        isDisplayNameSet?: boolean | null;
        isUsernameSet?: boolean | null;
        isEmailApproveSet?: boolean | null;
      } | null;
    } | null;
  } | null;
};

export type GetAudienceQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;

export type GetAudienceQuery = {
  __typename?: 'Query';
  getAudience?: Array<{
    __typename?: 'Audient';
    id: string;
    progress?: number | null;
    joinedAt?: string | null;
    customer?: {
      __typename?: 'User';
      id: string;
      name?: string | null;
      username: string;
      email?: string | null;
      avatarUrl?: string | null;
    } | null;
    tier?: { __typename?: 'Tier'; id: string; title: string; orderNumber: number } | null;
  }> | null;
};

export type GetProductsStatsQueryVariables = Exact<{
  productId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetProductsStatsQuery = {
  __typename?: 'Query';
  getProductsStats?: Array<{
    __typename?: 'ProductStats';
    productId: string;
    stats?: {
      __typename?: 'StatsRow';
      revenue?: number | null;
      sales?: number | null;
      views?: number | null;
      courseCompletions?: number | null;
    } | null;
  } | null> | null;
};

export type GetTotalStatsQueryVariables = Exact<{ [key: string]: never }>;

export type GetTotalStatsQuery = {
  __typename?: 'Query';
  getTotalStats?: {
    __typename?: 'StatsRow';
    revenue?: number | null;
    sales?: number | null;
    views?: number | null;
    courseCompletions?: number | null;
  } | null;
};

export type GetTierStatsQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;

export type GetTierStatsQuery = {
  __typename?: 'Query';
  getTierStats?: Array<{
    __typename?: 'TierStats';
    tierId: string;
    stats?: {
      __typename?: 'StatsRow';
      views?: number | null;
      sales?: number | null;
      revenue?: number | null;
      courseCompletions?: number | null;
      progress?: number | null;
    } | null;
  } | null> | null;
};

export type PageContentChangedSubscriptionVariables = Exact<{
  pageId: Scalars['ID']['input'];
}>;

export type PageContentChangedSubscription = {
  __typename?: 'Subscription';
  pageContentChanged?: {
    __typename?: 'Page';
    content?: any | null;
    id: string;
    title: string;
    description?: string | null;
    icon?: string | null;
    orderNumber: number;
    url?: string | null;
    scheduledPublishAt?: string | null;
    isScheduledPublishWithNotification?: boolean | null;
    isPublished?: boolean | null;
    publishedAt?: string | null;
    isMyPage?: boolean | null;
    isPurchased?: boolean | null;
    hasChanges?: boolean | null;
    userHasAccess?: boolean | null;
    hasPublicTier?: boolean | null;
    hasPaidTier?: boolean | null;
    isCompleted?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    pictureUrl?: string | null;
  } | null;
};

export type TriggerPageContentChangedMutationVariables = Exact<{
  triggerPageContentChangedId: Scalars['ID']['input'];
}>;

export type TriggerPageContentChangedMutation = {
  __typename?: 'Mutation';
  triggerPageContentChanged?: { __typename?: 'Page'; id: string } | null;
};

export type GetProductManagementQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;

export type GetProductManagementQuery = {
  __typename?: 'Query';
  getProduct?: {
    __typename?: 'Product';
    id: string;
    slug?: string | null;
    url?: string | null;
    title: string;
    description?: string | null;
    pictureUrl?: string | null;
    chatWidget?: any | null;
    userHasAccess?: boolean | null;
    hasChanges?: boolean | null;
    hasPublicTier?: boolean | null;
    hasPaidTier?: boolean | null;
    hasTiersBeenUpdated?: boolean | null;
    hasLandingBeenUpdated?: boolean | null;
    isPublished?: boolean | null;
    isPurchased?: boolean | null;
    isScheduledPublishWithNotification?: boolean | null;
    isMyProduct?: boolean | null;
    pageCount?: number | null;
    tierCount?: number | null;
    lowestPriceInCents?: number | null;
    lowestPriceCurrency?: string | null;
    lowestPriceId?: string | null;
    mainCurrency?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    publishedAt?: string | null;
    scheduledPublishAt?: string | null;
    author?: {
      __typename?: 'User';
      id: string;
      isMe?: boolean | null;
      email?: string | null;
      username: string;
      name?: string | null;
      url: string;
      role: UserRole;
      bio?: string | null;
      avatarUrl?: string | null;
      seoPictureUrl?: string | null;
      mainCurrency?: string | null;
      isPartner?: boolean | null;
      accessExperimentalFeatures?: boolean | null;
      hasVisitedGuide?: boolean | null;
      status?: UserStatus | null;
      userType?: UserType | null;
      isEmailApproved?: boolean | null;
      hasPassword?: boolean | null;
      isWaitListFormSubmitted?: boolean | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      lastSentEmailVerificationAt?: string | null;
      socialLinks?: Array<{ __typename?: 'SocialLink'; type: string; url: string }> | null;
      plan?: {
        __typename?: 'AuthorSubscription';
        id: string;
        name: string;
        frequency?: AuthorSubscriptionPlanFrequency | null;
        activatedAt?: string | null;
        expiresAt?: string | null;
        nextPaymentAt?: string | null;
        hasPromocodeApplied?: boolean | null;
      } | null;
      gettingStarted?: {
        __typename?: 'GettingStarted';
        hasProductCreated?: boolean | null;
        hasContentAdded?: boolean | null;
        hasTiersUpdated?: boolean | null;
        hasLaunchPageUpdated?: boolean | null;
        hasProductPublished?: boolean | null;
      } | null;
      invite?: {
        __typename?: 'AuthInvite';
        id: string;
        code: string;
        owner: { __typename?: 'AuthInviteOwner'; id: string; name: string; username: string };
        promocode?: {
          __typename?: 'AuthorSubscriptionPromocode';
          id: string;
          name: string;
          code: string;
        } | null;
      } | null;
      onboarding?: {
        __typename?: 'UserOnboarding';
        isDisplayNameSet?: boolean | null;
        isUsernameSet?: boolean | null;
        isEmailApproveSet?: boolean | null;
      } | null;
    } | null;
    productFolder?: {
      __typename?: 'ProductFolder';
      title?: string | null;
      slugName?: string | null;
      id?: string | null;
    } | null;
  } | null;
  getPages?: Array<{
    __typename?: 'Page';
    id: string;
    title: string;
    description?: string | null;
    icon?: string | null;
    orderNumber: number;
    url?: string | null;
    scheduledPublishAt?: string | null;
    isScheduledPublishWithNotification?: boolean | null;
    isPublished?: boolean | null;
    publishedAt?: string | null;
    isMyPage?: boolean | null;
    isPurchased?: boolean | null;
    hasChanges?: boolean | null;
    userHasAccess?: boolean | null;
    hasPublicTier?: boolean | null;
    hasPaidTier?: boolean | null;
    isCompleted?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    pictureUrl?: string | null;
  }> | null;
  getTiers?: Array<{
    __typename?: 'Tier';
    id: string;
    slugName?: string | null;
    orderNumber: number;
    title: string;
    description?: string | null;
    pictureUrl?: string | null;
    access?: ProductAccess | null;
    isEnabled?: boolean | null;
    priceInCents?: number | null;
    currency?: string | null;
    isCurrent?: boolean | null;
    pageCount?: number | null;
    pages?: Array<{
      __typename?: 'PageInTier';
      pageId: string;
      title?: string | null;
      icon?: string | null;
      isIncluded: boolean;
      orderNumber: number;
      description?: string | null;
    }> | null;
    appliedPromocode?: {
      __typename?: 'AppliedPromocode';
      title: string;
      code: string;
      discountInCents: number;
      priceInCents: number;
    } | null;
  }> | null;
  getLanding?: {
    __typename?: 'Landing';
    id: string;
    title?: string | null;
    subtitle?: string | null;
    tiersHeader?: string | null;
    content?: any | null;
    media?: {
      __typename?: 'LandingMedia';
      type: LandingMediaType;
      provider: string;
      src: string;
      isFullSize: boolean;
      videoId?: string | null;
      coverUrl?: string | null;
      status?: CustomVideoStatus | null;
    } | null;
  } | null;
};

export type LandingFragmentFragment = {
  __typename?: 'Landing';
  id: string;
  title?: string | null;
  subtitle?: string | null;
  tiersHeader?: string | null;
  content?: any | null;
  media?: {
    __typename?: 'LandingMedia';
    type: LandingMediaType;
    provider: string;
    src: string;
    isFullSize: boolean;
    videoId?: string | null;
    coverUrl?: string | null;
    status?: CustomVideoStatus | null;
  } | null;
};

export type PageFragmentFragment = {
  __typename?: 'Page';
  content?: any | null;
  id: string;
  title: string;
  description?: string | null;
  icon?: string | null;
  orderNumber: number;
  url?: string | null;
  scheduledPublishAt?: string | null;
  isScheduledPublishWithNotification?: boolean | null;
  isPublished?: boolean | null;
  publishedAt?: string | null;
  isMyPage?: boolean | null;
  isPurchased?: boolean | null;
  hasChanges?: boolean | null;
  userHasAccess?: boolean | null;
  hasPublicTier?: boolean | null;
  hasPaidTier?: boolean | null;
  isCompleted?: boolean | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  pictureUrl?: string | null;
};

export type PageInListFragmentFragment = {
  __typename?: 'Page';
  id: string;
  title: string;
  description?: string | null;
  icon?: string | null;
  orderNumber: number;
  url?: string | null;
  scheduledPublishAt?: string | null;
  isScheduledPublishWithNotification?: boolean | null;
  isPublished?: boolean | null;
  publishedAt?: string | null;
  isMyPage?: boolean | null;
  isPurchased?: boolean | null;
  hasChanges?: boolean | null;
  userHasAccess?: boolean | null;
  hasPublicTier?: boolean | null;
  hasPaidTier?: boolean | null;
  isCompleted?: boolean | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  pictureUrl?: string | null;
};

export type ProductFolderFragmentFragment = {
  __typename?: 'ProductFolder';
  title?: string | null;
  slugName?: string | null;
  id?: string | null;
};

export type ProductFragmentFragment = {
  __typename?: 'Product';
  id: string;
  slug?: string | null;
  url?: string | null;
  title: string;
  description?: string | null;
  pictureUrl?: string | null;
  chatWidget?: any | null;
  userHasAccess?: boolean | null;
  hasChanges?: boolean | null;
  hasPublicTier?: boolean | null;
  hasPaidTier?: boolean | null;
  hasTiersBeenUpdated?: boolean | null;
  hasLandingBeenUpdated?: boolean | null;
  isPublished?: boolean | null;
  isPurchased?: boolean | null;
  isScheduledPublishWithNotification?: boolean | null;
  isMyProduct?: boolean | null;
  pageCount?: number | null;
  tierCount?: number | null;
  lowestPriceInCents?: number | null;
  lowestPriceCurrency?: string | null;
  lowestPriceId?: string | null;
  mainCurrency?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  publishedAt?: string | null;
  scheduledPublishAt?: string | null;
  author?: {
    __typename?: 'User';
    id: string;
    isMe?: boolean | null;
    email?: string | null;
    username: string;
    name?: string | null;
    url: string;
    role: UserRole;
    bio?: string | null;
    avatarUrl?: string | null;
    seoPictureUrl?: string | null;
    mainCurrency?: string | null;
    isPartner?: boolean | null;
    accessExperimentalFeatures?: boolean | null;
    hasVisitedGuide?: boolean | null;
    status?: UserStatus | null;
    userType?: UserType | null;
    isEmailApproved?: boolean | null;
    hasPassword?: boolean | null;
    isWaitListFormSubmitted?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    lastSentEmailVerificationAt?: string | null;
    socialLinks?: Array<{ __typename?: 'SocialLink'; type: string; url: string }> | null;
    plan?: {
      __typename?: 'AuthorSubscription';
      id: string;
      name: string;
      frequency?: AuthorSubscriptionPlanFrequency | null;
      activatedAt?: string | null;
      expiresAt?: string | null;
      nextPaymentAt?: string | null;
      hasPromocodeApplied?: boolean | null;
    } | null;
    gettingStarted?: {
      __typename?: 'GettingStarted';
      hasProductCreated?: boolean | null;
      hasContentAdded?: boolean | null;
      hasTiersUpdated?: boolean | null;
      hasLaunchPageUpdated?: boolean | null;
      hasProductPublished?: boolean | null;
    } | null;
    invite?: {
      __typename?: 'AuthInvite';
      id: string;
      code: string;
      owner: { __typename?: 'AuthInviteOwner'; id: string; name: string; username: string };
      promocode?: {
        __typename?: 'AuthorSubscriptionPromocode';
        id: string;
        name: string;
        code: string;
      } | null;
    } | null;
    onboarding?: {
      __typename?: 'UserOnboarding';
      isDisplayNameSet?: boolean | null;
      isUsernameSet?: boolean | null;
      isEmailApproveSet?: boolean | null;
    } | null;
  } | null;
  productFolder?: {
    __typename?: 'ProductFolder';
    title?: string | null;
    slugName?: string | null;
    id?: string | null;
  } | null;
};

export type TierFragmentFragment = {
  __typename?: 'Tier';
  id: string;
  slugName?: string | null;
  orderNumber: number;
  title: string;
  description?: string | null;
  pictureUrl?: string | null;
  access?: ProductAccess | null;
  isEnabled?: boolean | null;
  priceInCents?: number | null;
  currency?: string | null;
  isCurrent?: boolean | null;
  pageCount?: number | null;
  pages?: Array<{
    __typename?: 'PageInTier';
    pageId: string;
    title?: string | null;
    icon?: string | null;
    isIncluded: boolean;
    orderNumber: number;
    description?: string | null;
  }> | null;
  appliedPromocode?: {
    __typename?: 'AppliedPromocode';
    title: string;
    code: string;
    discountInCents: number;
    priceInCents: number;
  } | null;
};

export type GetCustomVideoQueryVariables = Exact<{
  guid: Scalars['ID']['input'];
}>;

export type GetCustomVideoQuery = {
  __typename?: 'Query';
  getCustomVideo?: {
    __typename?: 'CustomVideo';
    id: string;
    guid: string;
    status: CustomVideoStatus;
    transcodingProgress?: number | null;
  } | null;
};

export type GetLandingQueryVariables = Exact<{
  getLandingProductId: Scalars['ID']['input'];
}>;

export type GetLandingQuery = {
  __typename?: 'Query';
  getLanding?: {
    __typename?: 'Landing';
    id: string;
    title?: string | null;
    subtitle?: string | null;
    tiersHeader?: string | null;
    content?: any | null;
    media?: {
      __typename?: 'LandingMedia';
      type: LandingMediaType;
      provider: string;
      src: string;
      isFullSize: boolean;
      videoId?: string | null;
      coverUrl?: string | null;
      status?: CustomVideoStatus | null;
    } | null;
  } | null;
};

export type GetPublishedLandingQueryVariables = Exact<{
  getPublishedLandingProductId: Scalars['ID']['input'];
}>;

export type GetPublishedLandingQuery = {
  __typename?: 'Query';
  getPublishedLanding?: {
    __typename?: 'Landing';
    id: string;
    title?: string | null;
    subtitle?: string | null;
    tiersHeader?: string | null;
    content?: any | null;
    media?: {
      __typename?: 'LandingMedia';
      type: LandingMediaType;
      provider: string;
      src: string;
      isFullSize: boolean;
      videoId?: string | null;
      coverUrl?: string | null;
      status?: CustomVideoStatus | null;
    } | null;
  } | null;
};

export type UpdateLandingMutationVariables = Exact<{
  input: UpdateLandingInput;
}>;

export type UpdateLandingMutation = {
  __typename?: 'Mutation';
  updateLanding?: {
    __typename?: 'Landing';
    id: string;
    title?: string | null;
    subtitle?: string | null;
    tiersHeader?: string | null;
    content?: any | null;
    media?: {
      __typename?: 'LandingMedia';
      type: LandingMediaType;
      provider: string;
      src: string;
      isFullSize: boolean;
      videoId?: string | null;
      coverUrl?: string | null;
      status?: CustomVideoStatus | null;
    } | null;
  } | null;
};

export type ArchivePageMutationVariables = Exact<{
  archivePageId: Scalars['ID']['input'];
}>;

export type ArchivePageMutation = { __typename?: 'Mutation'; archivePage?: boolean | null };

export type CancelScheduledPagePublishMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type CancelScheduledPagePublishMutation = {
  __typename?: 'Mutation';
  cancelScheduledPagePublish?: boolean | null;
};

export type CreatePageMutationVariables = Exact<{
  input: AddPageInput;
}>;

export type CreatePageMutation = {
  __typename?: 'Mutation';
  addPage?: {
    __typename?: 'Page';
    content?: any | null;
    id: string;
    title: string;
    description?: string | null;
    icon?: string | null;
    orderNumber: number;
    url?: string | null;
    scheduledPublishAt?: string | null;
    isScheduledPublishWithNotification?: boolean | null;
    isPublished?: boolean | null;
    publishedAt?: string | null;
    isMyPage?: boolean | null;
    isPurchased?: boolean | null;
    hasChanges?: boolean | null;
    userHasAccess?: boolean | null;
    hasPublicTier?: boolean | null;
    hasPaidTier?: boolean | null;
    isCompleted?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    pictureUrl?: string | null;
  } | null;
};

export type GetPageQueryVariables = Exact<{
  getPageId: Scalars['ID']['input'];
}>;

export type GetPageQuery = {
  __typename?: 'Query';
  getPage?: {
    __typename?: 'Page';
    isPurchased?: boolean | null;
    content?: any | null;
    id: string;
    title: string;
    description?: string | null;
    icon?: string | null;
    orderNumber: number;
    url?: string | null;
    scheduledPublishAt?: string | null;
    isScheduledPublishWithNotification?: boolean | null;
    isPublished?: boolean | null;
    publishedAt?: string | null;
    isMyPage?: boolean | null;
    hasChanges?: boolean | null;
    userHasAccess?: boolean | null;
    hasPublicTier?: boolean | null;
    hasPaidTier?: boolean | null;
    isCompleted?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    pictureUrl?: string | null;
  } | null;
};

export type GetPagesQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;

export type GetPagesQuery = {
  __typename?: 'Query';
  getPages?: Array<{
    __typename?: 'Page';
    id: string;
    title: string;
    description?: string | null;
    icon?: string | null;
    orderNumber: number;
    url?: string | null;
    scheduledPublishAt?: string | null;
    isScheduledPublishWithNotification?: boolean | null;
    isPublished?: boolean | null;
    publishedAt?: string | null;
    isMyPage?: boolean | null;
    isPurchased?: boolean | null;
    hasChanges?: boolean | null;
    userHasAccess?: boolean | null;
    hasPublicTier?: boolean | null;
    hasPaidTier?: boolean | null;
    isCompleted?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    pictureUrl?: string | null;
  }> | null;
};

export type GetPublishedPageQueryVariables = Exact<{
  getPublishedProductId: Scalars['ID']['input'];
  getPublishedPageId: Scalars['ID']['input'];
}>;

export type GetPublishedPageQuery = {
  __typename?: 'Query';
  getPublishedPage?: {
    __typename?: 'Page';
    isPurchased?: boolean | null;
    content?: any | null;
    id: string;
    title: string;
    description?: string | null;
    icon?: string | null;
    orderNumber: number;
    url?: string | null;
    scheduledPublishAt?: string | null;
    isScheduledPublishWithNotification?: boolean | null;
    isPublished?: boolean | null;
    publishedAt?: string | null;
    isMyPage?: boolean | null;
    hasChanges?: boolean | null;
    userHasAccess?: boolean | null;
    hasPublicTier?: boolean | null;
    hasPaidTier?: boolean | null;
    isCompleted?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    pictureUrl?: string | null;
  } | null;
};

export type GetPublishedPagesQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;

export type GetPublishedPagesQuery = {
  __typename?: 'Query';
  getPublishedPages?: Array<{
    __typename?: 'Page';
    id: string;
    title: string;
    description?: string | null;
    icon?: string | null;
    orderNumber: number;
    url?: string | null;
    scheduledPublishAt?: string | null;
    isScheduledPublishWithNotification?: boolean | null;
    isPublished?: boolean | null;
    publishedAt?: string | null;
    isMyPage?: boolean | null;
    isPurchased?: boolean | null;
    hasChanges?: boolean | null;
    userHasAccess?: boolean | null;
    hasPublicTier?: boolean | null;
    hasPaidTier?: boolean | null;
    isCompleted?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    pictureUrl?: string | null;
  }> | null;
};

export type PublishPageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PublishPageMutation = { __typename?: 'Mutation'; publishPage?: boolean | null };

export type ReadPageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ReadPageMutation = {
  __typename?: 'Mutation';
  completePage?: {
    __typename?: 'CompletePageResult';
    pageCompleted?: boolean | null;
    courseCompleted?: boolean | null;
  } | null;
};

export type SchedulePagePublishMutationVariables = Exact<{
  input: SchedulePagePublishInput;
}>;

export type SchedulePagePublishMutation = {
  __typename?: 'Mutation';
  schedulePagePublish?: boolean | null;
};

export type UnpublishPageMutationVariables = Exact<{
  unpublishPageId: Scalars['ID']['input'];
}>;

export type UnpublishPageMutation = { __typename?: 'Mutation'; unpublishPage?: boolean | null };

export type UpdatePageMutationVariables = Exact<{
  input: UpdatePageInput;
}>;

export type UpdatePageMutation = {
  __typename?: 'Mutation';
  updatePage?: {
    __typename?: 'Page';
    content?: any | null;
    id: string;
    title: string;
    description?: string | null;
    icon?: string | null;
    orderNumber: number;
    url?: string | null;
    scheduledPublishAt?: string | null;
    isScheduledPublishWithNotification?: boolean | null;
    isPublished?: boolean | null;
    publishedAt?: string | null;
    isMyPage?: boolean | null;
    isPurchased?: boolean | null;
    hasChanges?: boolean | null;
    userHasAccess?: boolean | null;
    hasPublicTier?: boolean | null;
    hasPaidTier?: boolean | null;
    isCompleted?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    pictureUrl?: string | null;
  } | null;
};

export type ArchiveProductMutationVariables = Exact<{
  archiveProductId: Scalars['ID']['input'];
}>;

export type ArchiveProductMutation = { __typename?: 'Mutation'; archiveProduct?: boolean | null };

export type CancelScheduledProductPublishMutationVariables = Exact<{
  cancelScheduledProductPublishId: Scalars['ID']['input'];
}>;

export type CancelScheduledProductPublishMutation = {
  __typename?: 'Mutation';
  cancelScheduledProductPublish?: boolean | null;
};

export type CreateProductMutationVariables = Exact<{
  input: CreateProductInput;
}>;

export type CreateProductMutation = {
  __typename?: 'Mutation';
  createProduct?: {
    __typename?: 'Product';
    id: string;
    slug?: string | null;
    url?: string | null;
    title: string;
    description?: string | null;
    pictureUrl?: string | null;
    chatWidget?: any | null;
    userHasAccess?: boolean | null;
    hasChanges?: boolean | null;
    hasPublicTier?: boolean | null;
    hasPaidTier?: boolean | null;
    hasTiersBeenUpdated?: boolean | null;
    hasLandingBeenUpdated?: boolean | null;
    isPublished?: boolean | null;
    isPurchased?: boolean | null;
    isScheduledPublishWithNotification?: boolean | null;
    isMyProduct?: boolean | null;
    pageCount?: number | null;
    tierCount?: number | null;
    lowestPriceInCents?: number | null;
    lowestPriceCurrency?: string | null;
    lowestPriceId?: string | null;
    mainCurrency?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    publishedAt?: string | null;
    scheduledPublishAt?: string | null;
    author?: {
      __typename?: 'User';
      id: string;
      isMe?: boolean | null;
      email?: string | null;
      username: string;
      name?: string | null;
      url: string;
      role: UserRole;
      bio?: string | null;
      avatarUrl?: string | null;
      seoPictureUrl?: string | null;
      mainCurrency?: string | null;
      isPartner?: boolean | null;
      accessExperimentalFeatures?: boolean | null;
      hasVisitedGuide?: boolean | null;
      status?: UserStatus | null;
      userType?: UserType | null;
      isEmailApproved?: boolean | null;
      hasPassword?: boolean | null;
      isWaitListFormSubmitted?: boolean | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      lastSentEmailVerificationAt?: string | null;
      socialLinks?: Array<{ __typename?: 'SocialLink'; type: string; url: string }> | null;
      plan?: {
        __typename?: 'AuthorSubscription';
        id: string;
        name: string;
        frequency?: AuthorSubscriptionPlanFrequency | null;
        activatedAt?: string | null;
        expiresAt?: string | null;
        nextPaymentAt?: string | null;
        hasPromocodeApplied?: boolean | null;
      } | null;
      gettingStarted?: {
        __typename?: 'GettingStarted';
        hasProductCreated?: boolean | null;
        hasContentAdded?: boolean | null;
        hasTiersUpdated?: boolean | null;
        hasLaunchPageUpdated?: boolean | null;
        hasProductPublished?: boolean | null;
      } | null;
      invite?: {
        __typename?: 'AuthInvite';
        id: string;
        code: string;
        owner: { __typename?: 'AuthInviteOwner'; id: string; name: string; username: string };
        promocode?: {
          __typename?: 'AuthorSubscriptionPromocode';
          id: string;
          name: string;
          code: string;
        } | null;
      } | null;
      onboarding?: {
        __typename?: 'UserOnboarding';
        isDisplayNameSet?: boolean | null;
        isUsernameSet?: boolean | null;
        isEmailApproveSet?: boolean | null;
      } | null;
    } | null;
    productFolder?: {
      __typename?: 'ProductFolder';
      title?: string | null;
      slugName?: string | null;
      id?: string | null;
    } | null;
  } | null;
};

export type DuplicateProductMutationVariables = Exact<{
  input: DuplicateProductInput;
}>;

export type DuplicateProductMutation = {
  __typename?: 'Mutation';
  duplicateProduct?: {
    __typename?: 'Product';
    id: string;
    slug?: string | null;
    url?: string | null;
    title: string;
    description?: string | null;
    pictureUrl?: string | null;
    chatWidget?: any | null;
    userHasAccess?: boolean | null;
    hasChanges?: boolean | null;
    hasPublicTier?: boolean | null;
    hasPaidTier?: boolean | null;
    hasTiersBeenUpdated?: boolean | null;
    hasLandingBeenUpdated?: boolean | null;
    isPublished?: boolean | null;
    isPurchased?: boolean | null;
    isScheduledPublishWithNotification?: boolean | null;
    isMyProduct?: boolean | null;
    pageCount?: number | null;
    tierCount?: number | null;
    lowestPriceInCents?: number | null;
    lowestPriceCurrency?: string | null;
    lowestPriceId?: string | null;
    mainCurrency?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    publishedAt?: string | null;
    scheduledPublishAt?: string | null;
    author?: {
      __typename?: 'User';
      id: string;
      isMe?: boolean | null;
      email?: string | null;
      username: string;
      name?: string | null;
      url: string;
      role: UserRole;
      bio?: string | null;
      avatarUrl?: string | null;
      seoPictureUrl?: string | null;
      mainCurrency?: string | null;
      isPartner?: boolean | null;
      accessExperimentalFeatures?: boolean | null;
      hasVisitedGuide?: boolean | null;
      status?: UserStatus | null;
      userType?: UserType | null;
      isEmailApproved?: boolean | null;
      hasPassword?: boolean | null;
      isWaitListFormSubmitted?: boolean | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      lastSentEmailVerificationAt?: string | null;
      socialLinks?: Array<{ __typename?: 'SocialLink'; type: string; url: string }> | null;
      plan?: {
        __typename?: 'AuthorSubscription';
        id: string;
        name: string;
        frequency?: AuthorSubscriptionPlanFrequency | null;
        activatedAt?: string | null;
        expiresAt?: string | null;
        nextPaymentAt?: string | null;
        hasPromocodeApplied?: boolean | null;
      } | null;
      gettingStarted?: {
        __typename?: 'GettingStarted';
        hasProductCreated?: boolean | null;
        hasContentAdded?: boolean | null;
        hasTiersUpdated?: boolean | null;
        hasLaunchPageUpdated?: boolean | null;
        hasProductPublished?: boolean | null;
      } | null;
      invite?: {
        __typename?: 'AuthInvite';
        id: string;
        code: string;
        owner: { __typename?: 'AuthInviteOwner'; id: string; name: string; username: string };
        promocode?: {
          __typename?: 'AuthorSubscriptionPromocode';
          id: string;
          name: string;
          code: string;
        } | null;
      } | null;
      onboarding?: {
        __typename?: 'UserOnboarding';
        isDisplayNameSet?: boolean | null;
        isUsernameSet?: boolean | null;
        isEmailApproveSet?: boolean | null;
      } | null;
    } | null;
    productFolder?: {
      __typename?: 'ProductFolder';
      title?: string | null;
      slugName?: string | null;
      id?: string | null;
    } | null;
  } | null;
};

export type GetProductQueryVariables = Exact<{
  getProductId: Scalars['ID']['input'];
}>;

export type GetProductQuery = {
  __typename?: 'Query';
  getProduct?: {
    __typename?: 'Product';
    id: string;
    slug?: string | null;
    url?: string | null;
    title: string;
    description?: string | null;
    pictureUrl?: string | null;
    chatWidget?: any | null;
    userHasAccess?: boolean | null;
    hasChanges?: boolean | null;
    hasPublicTier?: boolean | null;
    hasPaidTier?: boolean | null;
    hasTiersBeenUpdated?: boolean | null;
    hasLandingBeenUpdated?: boolean | null;
    isPublished?: boolean | null;
    isPurchased?: boolean | null;
    isScheduledPublishWithNotification?: boolean | null;
    isMyProduct?: boolean | null;
    pageCount?: number | null;
    tierCount?: number | null;
    lowestPriceInCents?: number | null;
    lowestPriceCurrency?: string | null;
    lowestPriceId?: string | null;
    mainCurrency?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    publishedAt?: string | null;
    scheduledPublishAt?: string | null;
    author?: {
      __typename?: 'User';
      id: string;
      isMe?: boolean | null;
      email?: string | null;
      username: string;
      name?: string | null;
      url: string;
      role: UserRole;
      bio?: string | null;
      avatarUrl?: string | null;
      seoPictureUrl?: string | null;
      mainCurrency?: string | null;
      isPartner?: boolean | null;
      accessExperimentalFeatures?: boolean | null;
      hasVisitedGuide?: boolean | null;
      status?: UserStatus | null;
      userType?: UserType | null;
      isEmailApproved?: boolean | null;
      hasPassword?: boolean | null;
      isWaitListFormSubmitted?: boolean | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      lastSentEmailVerificationAt?: string | null;
      socialLinks?: Array<{ __typename?: 'SocialLink'; type: string; url: string }> | null;
      plan?: {
        __typename?: 'AuthorSubscription';
        id: string;
        name: string;
        frequency?: AuthorSubscriptionPlanFrequency | null;
        activatedAt?: string | null;
        expiresAt?: string | null;
        nextPaymentAt?: string | null;
        hasPromocodeApplied?: boolean | null;
      } | null;
      gettingStarted?: {
        __typename?: 'GettingStarted';
        hasProductCreated?: boolean | null;
        hasContentAdded?: boolean | null;
        hasTiersUpdated?: boolean | null;
        hasLaunchPageUpdated?: boolean | null;
        hasProductPublished?: boolean | null;
      } | null;
      invite?: {
        __typename?: 'AuthInvite';
        id: string;
        code: string;
        owner: { __typename?: 'AuthInviteOwner'; id: string; name: string; username: string };
        promocode?: {
          __typename?: 'AuthorSubscriptionPromocode';
          id: string;
          name: string;
          code: string;
        } | null;
      } | null;
      onboarding?: {
        __typename?: 'UserOnboarding';
        isDisplayNameSet?: boolean | null;
        isUsernameSet?: boolean | null;
        isEmailApproveSet?: boolean | null;
      } | null;
    } | null;
    productFolder?: {
      __typename?: 'ProductFolder';
      title?: string | null;
      slugName?: string | null;
      id?: string | null;
    } | null;
  } | null;
};

export type GetProductsQueryVariables = Exact<{
  username: Scalars['String']['input'];
  filter?: InputMaybe<GetProductsFilter>;
}>;

export type GetProductsQuery = {
  __typename?: 'Query';
  getProducts?: Array<{
    __typename?: 'Product';
    id: string;
    slug?: string | null;
    url?: string | null;
    title: string;
    description?: string | null;
    pictureUrl?: string | null;
    chatWidget?: any | null;
    userHasAccess?: boolean | null;
    hasChanges?: boolean | null;
    hasPublicTier?: boolean | null;
    hasPaidTier?: boolean | null;
    hasTiersBeenUpdated?: boolean | null;
    hasLandingBeenUpdated?: boolean | null;
    isPublished?: boolean | null;
    isPurchased?: boolean | null;
    isScheduledPublishWithNotification?: boolean | null;
    isMyProduct?: boolean | null;
    pageCount?: number | null;
    tierCount?: number | null;
    lowestPriceInCents?: number | null;
    lowestPriceCurrency?: string | null;
    lowestPriceId?: string | null;
    mainCurrency?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    publishedAt?: string | null;
    scheduledPublishAt?: string | null;
    author?: {
      __typename?: 'User';
      id: string;
      isMe?: boolean | null;
      email?: string | null;
      username: string;
      name?: string | null;
      url: string;
      role: UserRole;
      bio?: string | null;
      avatarUrl?: string | null;
      seoPictureUrl?: string | null;
      mainCurrency?: string | null;
      isPartner?: boolean | null;
      accessExperimentalFeatures?: boolean | null;
      hasVisitedGuide?: boolean | null;
      status?: UserStatus | null;
      userType?: UserType | null;
      isEmailApproved?: boolean | null;
      hasPassword?: boolean | null;
      isWaitListFormSubmitted?: boolean | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      lastSentEmailVerificationAt?: string | null;
      socialLinks?: Array<{ __typename?: 'SocialLink'; type: string; url: string }> | null;
      plan?: {
        __typename?: 'AuthorSubscription';
        id: string;
        name: string;
        frequency?: AuthorSubscriptionPlanFrequency | null;
        activatedAt?: string | null;
        expiresAt?: string | null;
        nextPaymentAt?: string | null;
        hasPromocodeApplied?: boolean | null;
      } | null;
      gettingStarted?: {
        __typename?: 'GettingStarted';
        hasProductCreated?: boolean | null;
        hasContentAdded?: boolean | null;
        hasTiersUpdated?: boolean | null;
        hasLaunchPageUpdated?: boolean | null;
        hasProductPublished?: boolean | null;
      } | null;
      invite?: {
        __typename?: 'AuthInvite';
        id: string;
        code: string;
        owner: { __typename?: 'AuthInviteOwner'; id: string; name: string; username: string };
        promocode?: {
          __typename?: 'AuthorSubscriptionPromocode';
          id: string;
          name: string;
          code: string;
        } | null;
      } | null;
      onboarding?: {
        __typename?: 'UserOnboarding';
        isDisplayNameSet?: boolean | null;
        isUsernameSet?: boolean | null;
        isEmailApproveSet?: boolean | null;
      } | null;
    } | null;
    productFolder?: {
      __typename?: 'ProductFolder';
      title?: string | null;
      slugName?: string | null;
      id?: string | null;
    } | null;
  }> | null;
};

export type GetPublishedProductQueryVariables = Exact<{
  getPublishedProductId: Scalars['ID']['input'];
}>;

export type GetPublishedProductQuery = {
  __typename?: 'Query';
  getPublishedProduct?: {
    __typename?: 'Product';
    id: string;
    slug?: string | null;
    url?: string | null;
    title: string;
    description?: string | null;
    pictureUrl?: string | null;
    chatWidget?: any | null;
    userHasAccess?: boolean | null;
    hasChanges?: boolean | null;
    hasPublicTier?: boolean | null;
    hasPaidTier?: boolean | null;
    hasTiersBeenUpdated?: boolean | null;
    hasLandingBeenUpdated?: boolean | null;
    isPublished?: boolean | null;
    isPurchased?: boolean | null;
    isScheduledPublishWithNotification?: boolean | null;
    isMyProduct?: boolean | null;
    pageCount?: number | null;
    tierCount?: number | null;
    lowestPriceInCents?: number | null;
    lowestPriceCurrency?: string | null;
    lowestPriceId?: string | null;
    mainCurrency?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    publishedAt?: string | null;
    scheduledPublishAt?: string | null;
    author?: {
      __typename?: 'User';
      id: string;
      isMe?: boolean | null;
      email?: string | null;
      username: string;
      name?: string | null;
      url: string;
      role: UserRole;
      bio?: string | null;
      avatarUrl?: string | null;
      seoPictureUrl?: string | null;
      mainCurrency?: string | null;
      isPartner?: boolean | null;
      accessExperimentalFeatures?: boolean | null;
      hasVisitedGuide?: boolean | null;
      status?: UserStatus | null;
      userType?: UserType | null;
      isEmailApproved?: boolean | null;
      hasPassword?: boolean | null;
      isWaitListFormSubmitted?: boolean | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      lastSentEmailVerificationAt?: string | null;
      socialLinks?: Array<{ __typename?: 'SocialLink'; type: string; url: string }> | null;
      plan?: {
        __typename?: 'AuthorSubscription';
        id: string;
        name: string;
        frequency?: AuthorSubscriptionPlanFrequency | null;
        activatedAt?: string | null;
        expiresAt?: string | null;
        nextPaymentAt?: string | null;
        hasPromocodeApplied?: boolean | null;
      } | null;
      gettingStarted?: {
        __typename?: 'GettingStarted';
        hasProductCreated?: boolean | null;
        hasContentAdded?: boolean | null;
        hasTiersUpdated?: boolean | null;
        hasLaunchPageUpdated?: boolean | null;
        hasProductPublished?: boolean | null;
      } | null;
      invite?: {
        __typename?: 'AuthInvite';
        id: string;
        code: string;
        owner: { __typename?: 'AuthInviteOwner'; id: string; name: string; username: string };
        promocode?: {
          __typename?: 'AuthorSubscriptionPromocode';
          id: string;
          name: string;
          code: string;
        } | null;
      } | null;
      onboarding?: {
        __typename?: 'UserOnboarding';
        isDisplayNameSet?: boolean | null;
        isUsernameSet?: boolean | null;
        isEmailApproveSet?: boolean | null;
      } | null;
    } | null;
    productFolder?: {
      __typename?: 'ProductFolder';
      title?: string | null;
      slugName?: string | null;
      id?: string | null;
    } | null;
  } | null;
};

export type GetPublishedProductsQueryVariables = Exact<{
  username: Scalars['String']['input'];
  filter?: InputMaybe<GetPublishedProductsFilter>;
}>;

export type GetPublishedProductsQuery = {
  __typename?: 'Query';
  getPublishedProducts?: Array<{
    __typename?: 'Product';
    id: string;
    slug?: string | null;
    url?: string | null;
    title: string;
    description?: string | null;
    pictureUrl?: string | null;
    chatWidget?: any | null;
    userHasAccess?: boolean | null;
    hasChanges?: boolean | null;
    hasPublicTier?: boolean | null;
    hasPaidTier?: boolean | null;
    hasTiersBeenUpdated?: boolean | null;
    hasLandingBeenUpdated?: boolean | null;
    isPublished?: boolean | null;
    isPurchased?: boolean | null;
    isScheduledPublishWithNotification?: boolean | null;
    isMyProduct?: boolean | null;
    pageCount?: number | null;
    tierCount?: number | null;
    lowestPriceInCents?: number | null;
    lowestPriceCurrency?: string | null;
    lowestPriceId?: string | null;
    mainCurrency?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    publishedAt?: string | null;
    scheduledPublishAt?: string | null;
    author?: {
      __typename?: 'User';
      id: string;
      isMe?: boolean | null;
      email?: string | null;
      username: string;
      name?: string | null;
      url: string;
      role: UserRole;
      bio?: string | null;
      avatarUrl?: string | null;
      seoPictureUrl?: string | null;
      mainCurrency?: string | null;
      isPartner?: boolean | null;
      accessExperimentalFeatures?: boolean | null;
      hasVisitedGuide?: boolean | null;
      status?: UserStatus | null;
      userType?: UserType | null;
      isEmailApproved?: boolean | null;
      hasPassword?: boolean | null;
      isWaitListFormSubmitted?: boolean | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      lastSentEmailVerificationAt?: string | null;
      socialLinks?: Array<{ __typename?: 'SocialLink'; type: string; url: string }> | null;
      plan?: {
        __typename?: 'AuthorSubscription';
        id: string;
        name: string;
        frequency?: AuthorSubscriptionPlanFrequency | null;
        activatedAt?: string | null;
        expiresAt?: string | null;
        nextPaymentAt?: string | null;
        hasPromocodeApplied?: boolean | null;
      } | null;
      gettingStarted?: {
        __typename?: 'GettingStarted';
        hasProductCreated?: boolean | null;
        hasContentAdded?: boolean | null;
        hasTiersUpdated?: boolean | null;
        hasLaunchPageUpdated?: boolean | null;
        hasProductPublished?: boolean | null;
      } | null;
      invite?: {
        __typename?: 'AuthInvite';
        id: string;
        code: string;
        owner: { __typename?: 'AuthInviteOwner'; id: string; name: string; username: string };
        promocode?: {
          __typename?: 'AuthorSubscriptionPromocode';
          id: string;
          name: string;
          code: string;
        } | null;
      } | null;
      onboarding?: {
        __typename?: 'UserOnboarding';
        isDisplayNameSet?: boolean | null;
        isUsernameSet?: boolean | null;
        isEmailApproveSet?: boolean | null;
      } | null;
    } | null;
    productFolder?: {
      __typename?: 'ProductFolder';
      title?: string | null;
      slugName?: string | null;
      id?: string | null;
    } | null;
  }> | null;
};

export type PublishProductMutationVariables = Exact<{
  input: PublishProductInput;
}>;

export type PublishProductMutation = { __typename?: 'Mutation'; publishProduct?: boolean | null };

export type GetPurchasedProductsQueryVariables = Exact<{ [key: string]: never }>;

export type GetPurchasedProductsQuery = {
  __typename?: 'Query';
  getPurchasedProducts?: Array<{
    __typename?: 'Purchase';
    id: string;
    amountInCents?: number | null;
    amountCurrency?: string | null;
    purchasedAt?: string | null;
    product: {
      __typename?: 'Product';
      id: string;
      slug?: string | null;
      url?: string | null;
      title: string;
      description?: string | null;
      pictureUrl?: string | null;
      chatWidget?: any | null;
      userHasAccess?: boolean | null;
      hasChanges?: boolean | null;
      hasPublicTier?: boolean | null;
      hasPaidTier?: boolean | null;
      hasTiersBeenUpdated?: boolean | null;
      hasLandingBeenUpdated?: boolean | null;
      isPublished?: boolean | null;
      isPurchased?: boolean | null;
      isScheduledPublishWithNotification?: boolean | null;
      isMyProduct?: boolean | null;
      pageCount?: number | null;
      tierCount?: number | null;
      lowestPriceInCents?: number | null;
      lowestPriceCurrency?: string | null;
      lowestPriceId?: string | null;
      mainCurrency?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      publishedAt?: string | null;
      scheduledPublishAt?: string | null;
      author?: {
        __typename?: 'User';
        id: string;
        isMe?: boolean | null;
        email?: string | null;
        username: string;
        name?: string | null;
        url: string;
        role: UserRole;
        bio?: string | null;
        avatarUrl?: string | null;
        seoPictureUrl?: string | null;
        mainCurrency?: string | null;
        isPartner?: boolean | null;
        accessExperimentalFeatures?: boolean | null;
        hasVisitedGuide?: boolean | null;
        status?: UserStatus | null;
        userType?: UserType | null;
        isEmailApproved?: boolean | null;
        hasPassword?: boolean | null;
        isWaitListFormSubmitted?: boolean | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        lastSentEmailVerificationAt?: string | null;
        socialLinks?: Array<{ __typename?: 'SocialLink'; type: string; url: string }> | null;
        plan?: {
          __typename?: 'AuthorSubscription';
          id: string;
          name: string;
          frequency?: AuthorSubscriptionPlanFrequency | null;
          activatedAt?: string | null;
          expiresAt?: string | null;
          nextPaymentAt?: string | null;
          hasPromocodeApplied?: boolean | null;
        } | null;
        gettingStarted?: {
          __typename?: 'GettingStarted';
          hasProductCreated?: boolean | null;
          hasContentAdded?: boolean | null;
          hasTiersUpdated?: boolean | null;
          hasLaunchPageUpdated?: boolean | null;
          hasProductPublished?: boolean | null;
        } | null;
        invite?: {
          __typename?: 'AuthInvite';
          id: string;
          code: string;
          owner: { __typename?: 'AuthInviteOwner'; id: string; name: string; username: string };
          promocode?: {
            __typename?: 'AuthorSubscriptionPromocode';
            id: string;
            name: string;
            code: string;
          } | null;
        } | null;
        onboarding?: {
          __typename?: 'UserOnboarding';
          isDisplayNameSet?: boolean | null;
          isUsernameSet?: boolean | null;
          isEmailApproveSet?: boolean | null;
        } | null;
      } | null;
      productFolder?: {
        __typename?: 'ProductFolder';
        title?: string | null;
        slugName?: string | null;
        id?: string | null;
      } | null;
    };
    tier: {
      __typename?: 'Tier';
      id: string;
      slugName?: string | null;
      orderNumber: number;
      title: string;
      description?: string | null;
      pictureUrl?: string | null;
      access?: ProductAccess | null;
      isEnabled?: boolean | null;
      priceInCents?: number | null;
      currency?: string | null;
      isCurrent?: boolean | null;
      pageCount?: number | null;
      pages?: Array<{
        __typename?: 'PageInTier';
        pageId: string;
        title?: string | null;
        icon?: string | null;
        isIncluded: boolean;
        orderNumber: number;
        description?: string | null;
      }> | null;
      appliedPromocode?: {
        __typename?: 'AppliedPromocode';
        title: string;
        code: string;
        discountInCents: number;
        priceInCents: number;
      } | null;
    };
  }> | null;
};

export type ScheduleProductPublishMutationVariables = Exact<{
  input: ScheduleProductPublishInput;
}>;

export type ScheduleProductPublishMutation = {
  __typename?: 'Mutation';
  scheduleProductPublish?: boolean | null;
};

export type UnpublishProductMutationVariables = Exact<{
  unpublishProductId: Scalars['ID']['input'];
}>;

export type UnpublishProductMutation = {
  __typename?: 'Mutation';
  unpublishProduct?: boolean | null;
};

export type UpdateProductMutationVariables = Exact<{
  input: UpdateProductInput;
}>;

export type UpdateProductMutation = {
  __typename?: 'Mutation';
  updateProduct?: {
    __typename?: 'Product';
    id: string;
    slug?: string | null;
    url?: string | null;
    title: string;
    description?: string | null;
    pictureUrl?: string | null;
    chatWidget?: any | null;
    userHasAccess?: boolean | null;
    hasChanges?: boolean | null;
    hasPublicTier?: boolean | null;
    hasPaidTier?: boolean | null;
    hasTiersBeenUpdated?: boolean | null;
    hasLandingBeenUpdated?: boolean | null;
    isPublished?: boolean | null;
    isPurchased?: boolean | null;
    isScheduledPublishWithNotification?: boolean | null;
    isMyProduct?: boolean | null;
    pageCount?: number | null;
    tierCount?: number | null;
    lowestPriceInCents?: number | null;
    lowestPriceCurrency?: string | null;
    lowestPriceId?: string | null;
    mainCurrency?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    publishedAt?: string | null;
    scheduledPublishAt?: string | null;
    author?: {
      __typename?: 'User';
      id: string;
      isMe?: boolean | null;
      email?: string | null;
      username: string;
      name?: string | null;
      url: string;
      role: UserRole;
      bio?: string | null;
      avatarUrl?: string | null;
      seoPictureUrl?: string | null;
      mainCurrency?: string | null;
      isPartner?: boolean | null;
      accessExperimentalFeatures?: boolean | null;
      hasVisitedGuide?: boolean | null;
      status?: UserStatus | null;
      userType?: UserType | null;
      isEmailApproved?: boolean | null;
      hasPassword?: boolean | null;
      isWaitListFormSubmitted?: boolean | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      lastSentEmailVerificationAt?: string | null;
      socialLinks?: Array<{ __typename?: 'SocialLink'; type: string; url: string }> | null;
      plan?: {
        __typename?: 'AuthorSubscription';
        id: string;
        name: string;
        frequency?: AuthorSubscriptionPlanFrequency | null;
        activatedAt?: string | null;
        expiresAt?: string | null;
        nextPaymentAt?: string | null;
        hasPromocodeApplied?: boolean | null;
      } | null;
      gettingStarted?: {
        __typename?: 'GettingStarted';
        hasProductCreated?: boolean | null;
        hasContentAdded?: boolean | null;
        hasTiersUpdated?: boolean | null;
        hasLaunchPageUpdated?: boolean | null;
        hasProductPublished?: boolean | null;
      } | null;
      invite?: {
        __typename?: 'AuthInvite';
        id: string;
        code: string;
        owner: { __typename?: 'AuthInviteOwner'; id: string; name: string; username: string };
        promocode?: {
          __typename?: 'AuthorSubscriptionPromocode';
          id: string;
          name: string;
          code: string;
        } | null;
      } | null;
      onboarding?: {
        __typename?: 'UserOnboarding';
        isDisplayNameSet?: boolean | null;
        isUsernameSet?: boolean | null;
        isEmailApproveSet?: boolean | null;
      } | null;
    } | null;
    productFolder?: {
      __typename?: 'ProductFolder';
      title?: string | null;
      slugName?: string | null;
      id?: string | null;
    } | null;
  } | null;
};

export type CreateProductFolderMutationVariables = Exact<{
  input: CreateProductFolderInput;
}>;

export type CreateProductFolderMutation = {
  __typename?: 'Mutation';
  createProductFolder?: {
    __typename?: 'ProductFolder';
    title?: string | null;
    slugName?: string | null;
    id?: string | null;
  } | null;
};

export type GetProductFoldersQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type GetProductFoldersQuery = {
  __typename?: 'Query';
  getProductFolders?: Array<{
    __typename?: 'ProductFolder';
    title?: string | null;
    slugName?: string | null;
    id?: string | null;
  }> | null;
};

export type GetProductTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type GetProductTemplatesQuery = {
  __typename?: 'Query';
  getProductTemplates?: Array<{
    __typename?: 'ProductTemplate';
    id: string;
    slug?: string | null;
    url?: string | null;
    title: string;
    description?: string | null;
    pictureUrl?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  }> | null;
};

export type ArchiveTierMutationVariables = Exact<{
  archiveTierInput: ArchiveTierInput;
}>;

export type ArchiveTierMutation = { __typename?: 'Mutation'; archiveTier?: boolean | null };

export type GetPublishedFreeTierQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;

export type GetPublishedFreeTierQuery = {
  __typename?: 'Query';
  getPublishedFreeTier?: {
    __typename?: 'Tier';
    id: string;
    slugName?: string | null;
    orderNumber: number;
    title: string;
    description?: string | null;
    pictureUrl?: string | null;
    access?: ProductAccess | null;
    isEnabled?: boolean | null;
    priceInCents?: number | null;
    currency?: string | null;
    isCurrent?: boolean | null;
    pageCount?: number | null;
    pages?: Array<{
      __typename?: 'PageInTier';
      pageId: string;
      title?: string | null;
      icon?: string | null;
      isIncluded: boolean;
      orderNumber: number;
      description?: string | null;
    }> | null;
    appliedPromocode?: {
      __typename?: 'AppliedPromocode';
      title: string;
      code: string;
      discountInCents: number;
      priceInCents: number;
    } | null;
  } | null;
};

export type GetPublishedTiersQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  promocode?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetPublishedTiersQuery = {
  __typename?: 'Query';
  getPublishedTiers?: Array<{
    __typename?: 'Tier';
    id: string;
    slugName?: string | null;
    orderNumber: number;
    title: string;
    description?: string | null;
    pictureUrl?: string | null;
    access?: ProductAccess | null;
    isEnabled?: boolean | null;
    priceInCents?: number | null;
    currency?: string | null;
    isCurrent?: boolean | null;
    pageCount?: number | null;
    pages?: Array<{
      __typename?: 'PageInTier';
      pageId: string;
      title?: string | null;
      icon?: string | null;
      isIncluded: boolean;
      orderNumber: number;
      description?: string | null;
    }> | null;
    appliedPromocode?: {
      __typename?: 'AppliedPromocode';
      title: string;
      code: string;
      discountInCents: number;
      priceInCents: number;
    } | null;
  }> | null;
};

export type GetTiersQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  promocode?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetTiersQuery = {
  __typename?: 'Query';
  getTiers?: Array<{
    __typename?: 'Tier';
    id: string;
    slugName?: string | null;
    orderNumber: number;
    title: string;
    description?: string | null;
    pictureUrl?: string | null;
    access?: ProductAccess | null;
    isEnabled?: boolean | null;
    priceInCents?: number | null;
    currency?: string | null;
    isCurrent?: boolean | null;
    pageCount?: number | null;
    pages?: Array<{
      __typename?: 'PageInTier';
      pageId: string;
      title?: string | null;
      icon?: string | null;
      isIncluded: boolean;
      orderNumber: number;
      description?: string | null;
    }> | null;
    appliedPromocode?: {
      __typename?: 'AppliedPromocode';
      title: string;
      code: string;
      discountInCents: number;
      priceInCents: number;
    } | null;
  }> | null;
};

export type UpdateTiersMutationVariables = Exact<{
  input: UpdateTiersInput;
}>;

export type UpdateTiersMutation = {
  __typename?: 'Mutation';
  updateTiers?: Array<{
    __typename?: 'Tier';
    id: string;
    slugName?: string | null;
    orderNumber: number;
    title: string;
    description?: string | null;
    pictureUrl?: string | null;
    access?: ProductAccess | null;
    isEnabled?: boolean | null;
    priceInCents?: number | null;
    currency?: string | null;
    isCurrent?: boolean | null;
    pageCount?: number | null;
    pages?: Array<{
      __typename?: 'PageInTier';
      pageId: string;
      title?: string | null;
      icon?: string | null;
      isIncluded: boolean;
      orderNumber: number;
      description?: string | null;
    }> | null;
    appliedPromocode?: {
      __typename?: 'AppliedPromocode';
      title: string;
      code: string;
      discountInCents: number;
      priceInCents: number;
    } | null;
  }> | null;
};

export type GettingStartedFragmentFragment = {
  __typename?: 'GettingStarted';
  hasProductCreated?: boolean | null;
  hasContentAdded?: boolean | null;
  hasTiersUpdated?: boolean | null;
  hasLaunchPageUpdated?: boolean | null;
  hasProductPublished?: boolean | null;
};

export type GettingStartedUpdatedSubscriptionVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type GettingStartedUpdatedSubscription = {
  __typename?: 'Subscription';
  gettingStartedUpdated?: {
    __typename?: 'GettingStarted';
    hasProductCreated?: boolean | null;
    hasContentAdded?: boolean | null;
    hasTiersUpdated?: boolean | null;
    hasLaunchPageUpdated?: boolean | null;
    hasProductPublished?: boolean | null;
  } | null;
};

export type UpdateCustomVideoMutationVariables = Exact<{
  input: UpdateCustomVideoInput;
}>;

export type UpdateCustomVideoMutation = {
  __typename?: 'Mutation';
  updateCustomVideo?: {
    __typename?: 'CustomVideo';
    id: string;
    guid: string;
    status: CustomVideoStatus;
    transcodingProgress?: number | null;
    title?: string | null;
    url?: string | null;
    thumbnailUrl?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null;
};

export type UploadNewVideoMutationVariables = Exact<{
  input: UploadNewVideoInput;
}>;

export type UploadNewVideoMutation = {
  __typename?: 'Mutation';
  uploadNewVideo?: { __typename?: 'UploadNewVideo'; headers?: any | null } | null;
};

export const AuthorSubscriptionFragmentFragmentDoc = `
    fragment AuthorSubscriptionFragment on AuthorSubscription {
  id
  name
  frequency
  activatedAt
  expiresAt
  nextPaymentAt
  hasPromocodeApplied
}
    `;
export const GettingStartedFragmentFragmentDoc = `
    fragment GettingStartedFragment on GettingStarted {
  hasProductCreated
  hasContentAdded
  hasTiersUpdated
  hasLaunchPageUpdated
  hasProductPublished
}
    `;
export const UserFragmentFragmentDoc = `
    fragment UserFragment on User {
  id
  isMe
  email
  username
  name
  url
  role
  bio
  avatarUrl
  socialLinks {
    type
    url
  }
  seoPictureUrl
  mainCurrency
  isPartner
  accessExperimentalFeatures
  plan {
    ...AuthorSubscriptionFragment
  }
  gettingStarted {
    ...GettingStartedFragment
  }
  hasVisitedGuide
  status
  userType
  isEmailApproved
  hasPassword
  isWaitListFormSubmitted
  invite {
    id
    code
    owner {
      id
      name
      username
    }
    promocode {
      id
      name
      code
    }
  }
  onboarding {
    isDisplayNameSet
    isUsernameSet
    isEmailApproveSet
  }
  createdAt
  updatedAt
  lastSentEmailVerificationAt
}
    ${AuthorSubscriptionFragmentFragmentDoc}
${GettingStartedFragmentFragmentDoc}`;
export const UserSessionFragmentFragmentDoc = `
    fragment UserSessionFragment on UserSession {
  session {
    token
    expiresAt
  }
  user {
    ...UserFragment
  }
  isNewCustomer
}
    ${UserFragmentFragmentDoc}`;
export const LandingFragmentFragmentDoc = `
    fragment LandingFragment on Landing {
  id
  title
  subtitle
  tiersHeader
  content
  media {
    type
    provider
    src
    isFullSize
    videoId
    coverUrl
    status
  }
}
    `;
export const PageInListFragmentFragmentDoc = `
    fragment PageInListFragment on Page {
  id
  title
  description
  icon
  orderNumber
  url
  scheduledPublishAt
  isScheduledPublishWithNotification
  isPublished
  publishedAt
  isMyPage
  isPurchased
  hasChanges
  userHasAccess
  hasPublicTier
  hasPaidTier
  isCompleted
  createdAt
  updatedAt
  pictureUrl
}
    `;
export const PageFragmentFragmentDoc = `
    fragment PageFragment on Page {
  ...PageInListFragment
  content
}
    ${PageInListFragmentFragmentDoc}`;
export const ProductFolderFragmentFragmentDoc = `
    fragment ProductFolderFragment on ProductFolder {
  title
  slugName
  id
}
    `;
export const ProductFragmentFragmentDoc = `
    fragment ProductFragment on Product {
  id
  slug
  url
  title
  description
  pictureUrl
  chatWidget
  userHasAccess
  hasChanges
  hasPublicTier
  hasPaidTier
  hasTiersBeenUpdated
  hasLandingBeenUpdated
  isPublished
  isPurchased
  isScheduledPublishWithNotification
  isMyProduct
  pageCount
  tierCount
  lowestPriceInCents
  lowestPriceCurrency
  lowestPriceId
  mainCurrency
  createdAt
  updatedAt
  publishedAt
  scheduledPublishAt
  author {
    ...UserFragment
  }
  productFolder {
    ...ProductFolderFragment
  }
}
    ${UserFragmentFragmentDoc}
${ProductFolderFragmentFragmentDoc}`;
export const TierFragmentFragmentDoc = `
    fragment TierFragment on Tier {
  id
  slugName
  orderNumber
  title
  description
  pictureUrl
  access
  isEnabled
  priceInCents
  currency
  isCurrent
  pageCount
  pages {
    pageId
    title
    icon
    isIncluded
    orderNumber
    description
  }
  appliedPromocode {
    title
    code
    discountInCents
    priceInCents
  }
}
    `;
export const BecomeAnAuthorDocument = `
    mutation BecomeAnAuthor {
  becomeAnAuthor {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;

export const useBecomeAnAuthorMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    BecomeAnAuthorMutation,
    TError,
    BecomeAnAuthorMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers']
) => {
  return useMutation<BecomeAnAuthorMutation, TError, BecomeAnAuthorMutationVariables, TContext>({
    mutationKey: ['BecomeAnAuthor'],
    mutationFn: (variables?: BecomeAnAuthorMutationVariables) =>
      fetcher<BecomeAnAuthorMutation, BecomeAnAuthorMutationVariables>(
        client,
        BecomeAnAuthorDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const ConnectStripeDocument = `
    mutation ConnectStripe($input: connectStripeInput!) {
  connectStripe(input: $input) {
    redirectUrl
  }
}
    `;

export const useConnectStripeMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    ConnectStripeMutation,
    TError,
    ConnectStripeMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers']
) => {
  return useMutation<ConnectStripeMutation, TError, ConnectStripeMutationVariables, TContext>({
    mutationKey: ['ConnectStripe'],
    mutationFn: (variables?: ConnectStripeMutationVariables) =>
      fetcher<ConnectStripeMutation, ConnectStripeMutationVariables>(
        client,
        ConnectStripeDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const ContinueStripeOnboardingDocument = `
    mutation ContinueStripeOnboarding($input: continueStripeOnboardingInput!) {
  continueStripeOnboarding(input: $input) {
    redirectUrl
  }
}
    `;

export const useContinueStripeOnboardingMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    ContinueStripeOnboardingMutation,
    TError,
    ContinueStripeOnboardingMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers']
) => {
  return useMutation<
    ContinueStripeOnboardingMutation,
    TError,
    ContinueStripeOnboardingMutationVariables,
    TContext
  >({
    mutationKey: ['ContinueStripeOnboarding'],
    mutationFn: (variables?: ContinueStripeOnboardingMutationVariables) =>
      fetcher<ContinueStripeOnboardingMutation, ContinueStripeOnboardingMutationVariables>(
        client,
        ContinueStripeOnboardingDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const DowngradeAuthorSubscriptionDocument = `
    mutation DowngradeAuthorSubscription {
  downgradeAuthorSubscription
}
    `;

export const useDowngradeAuthorSubscriptionMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    DowngradeAuthorSubscriptionMutation,
    TError,
    DowngradeAuthorSubscriptionMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers']
) => {
  return useMutation<
    DowngradeAuthorSubscriptionMutation,
    TError,
    DowngradeAuthorSubscriptionMutationVariables,
    TContext
  >({
    mutationKey: ['DowngradeAuthorSubscription'],
    mutationFn: (variables?: DowngradeAuthorSubscriptionMutationVariables) =>
      fetcher<DowngradeAuthorSubscriptionMutation, DowngradeAuthorSubscriptionMutationVariables>(
        client,
        DowngradeAuthorSubscriptionDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const GetInviteByCodeDocument = `
    query GetInviteByCode($code: String!) {
  getInviteByCode(code: $code) {
    id
    code
    owner {
      id
      name
      username
    }
  }
}
    `;

export const useGetInviteByCodeQuery = <TData = GetInviteByCodeQuery, TError = unknown>(
  client: GraphQLClient,
  variables: GetInviteByCodeQueryVariables,
  options?: Omit<UseQueryOptions<GetInviteByCodeQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetInviteByCodeQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers']
) => {
  return useQuery<GetInviteByCodeQuery, TError, TData>({
    queryKey: ['GetInviteByCode', variables],
    queryFn: fetcher<GetInviteByCodeQuery, GetInviteByCodeQueryVariables>(
      client,
      GetInviteByCodeDocument,
      variables,
      headers
    ),
    ...options,
  });
};

export const GoToStripeDashboardDocument = `
    mutation GoToStripeDashboard {
  goToStripeDashboard {
    redirectUrl
  }
}
    `;

export const useGoToStripeDashboardMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    GoToStripeDashboardMutation,
    TError,
    GoToStripeDashboardMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers']
) => {
  return useMutation<
    GoToStripeDashboardMutation,
    TError,
    GoToStripeDashboardMutationVariables,
    TContext
  >({
    mutationKey: ['GoToStripeDashboard'],
    mutationFn: (variables?: GoToStripeDashboardMutationVariables) =>
      fetcher<GoToStripeDashboardMutation, GoToStripeDashboardMutationVariables>(
        client,
        GoToStripeDashboardDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const LogOutDocument = `
    mutation LogOut {
  logOut
}
    `;

export const useLogOutMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<LogOutMutation, TError, LogOutMutationVariables, TContext>,
  headers?: RequestInit['headers']
) => {
  return useMutation<LogOutMutation, TError, LogOutMutationVariables, TContext>({
    mutationKey: ['LogOut'],
    mutationFn: (variables?: LogOutMutationVariables) =>
      fetcher<LogOutMutation, LogOutMutationVariables>(
        client,
        LogOutDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const LoginWithEmailCodeDocument = `
    mutation LoginWithEmailCode($input: loginWithEmailCodeInput!) {
  loginWithEmailCode(input: $input)
}
    `;

export const useLoginWithEmailCodeMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    LoginWithEmailCodeMutation,
    TError,
    LoginWithEmailCodeMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers']
) => {
  return useMutation<
    LoginWithEmailCodeMutation,
    TError,
    LoginWithEmailCodeMutationVariables,
    TContext
  >({
    mutationKey: ['LoginWithEmailCode'],
    mutationFn: (variables?: LoginWithEmailCodeMutationVariables) =>
      fetcher<LoginWithEmailCodeMutation, LoginWithEmailCodeMutationVariables>(
        client,
        LoginWithEmailCodeDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const LoginWithGoogleDocument = `
    mutation LoginWithGoogle($input: loginWithGoogleInput!) {
  loginWithGoogle(input: $input) {
    ...UserSessionFragment
  }
}
    ${UserSessionFragmentFragmentDoc}`;

export const useLoginWithGoogleMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    LoginWithGoogleMutation,
    TError,
    LoginWithGoogleMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers']
) => {
  return useMutation<LoginWithGoogleMutation, TError, LoginWithGoogleMutationVariables, TContext>({
    mutationKey: ['LoginWithGoogle'],
    mutationFn: (variables?: LoginWithGoogleMutationVariables) =>
      fetcher<LoginWithGoogleMutation, LoginWithGoogleMutationVariables>(
        client,
        LoginWithGoogleDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const PingDocument = `
    query Ping {
  ping {
    session {
      token
      expiresAt
    }
    user {
      ...UserFragment
    }
  }
}
    ${UserFragmentFragmentDoc}`;

export const usePingQuery = <TData = PingQuery, TError = unknown>(
  client: GraphQLClient,
  variables?: PingQueryVariables,
  options?: Omit<UseQueryOptions<PingQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<PingQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers']
) => {
  return useQuery<PingQuery, TError, TData>({
    queryKey: variables === undefined ? ['Ping'] : ['Ping', variables],
    queryFn: fetcher<PingQuery, PingQueryVariables>(client, PingDocument, variables, headers),
    ...options,
  });
};

export const PurchaseProductDocument = `
    mutation PurchaseProduct($input: purchaseInput!) {
  purchase(input: $input) {
    user {
      ...UserFragment
    }
    session {
      token
      expiresAt
    }
    isNewCustomer
    wasAuthorized
    checkoutUrl
  }
}
    ${UserFragmentFragmentDoc}`;

export const usePurchaseProductMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    PurchaseProductMutation,
    TError,
    PurchaseProductMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers']
) => {
  return useMutation<PurchaseProductMutation, TError, PurchaseProductMutationVariables, TContext>({
    mutationKey: ['PurchaseProduct'],
    mutationFn: (variables?: PurchaseProductMutationVariables) =>
      fetcher<PurchaseProductMutation, PurchaseProductMutationVariables>(
        client,
        PurchaseProductDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const PurchaseForFreeTierDocument = `
    mutation PurchaseForFreeTier($input: purchaseInput!) {
  purchaseForFreeTier(input: $input) {
    user {
      ...UserFragment
    }
    session {
      token
      expiresAt
    }
    isNewCustomer
    wasAuthorized
    checkoutUrl
  }
}
    ${UserFragmentFragmentDoc}`;

export const usePurchaseForFreeTierMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    PurchaseForFreeTierMutation,
    TError,
    PurchaseForFreeTierMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers']
) => {
  return useMutation<
    PurchaseForFreeTierMutation,
    TError,
    PurchaseForFreeTierMutationVariables,
    TContext
  >({
    mutationKey: ['PurchaseForFreeTier'],
    mutationFn: (variables?: PurchaseForFreeTierMutationVariables) =>
      fetcher<PurchaseForFreeTierMutation, PurchaseForFreeTierMutationVariables>(
        client,
        PurchaseForFreeTierDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const PurchaseUpgradeProductDocument = `
    mutation PurchaseUpgradeProduct($input: purchaseInput!) {
  purchaseUpgrade(input: $input) {
    user {
      ...UserFragment
    }
    session {
      token
      expiresAt
    }
    isNewCustomer
    wasAuthorized
    checkoutUrl
  }
}
    ${UserFragmentFragmentDoc}`;

export const usePurchaseUpgradeProductMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    PurchaseUpgradeProductMutation,
    TError,
    PurchaseUpgradeProductMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers']
) => {
  return useMutation<
    PurchaseUpgradeProductMutation,
    TError,
    PurchaseUpgradeProductMutationVariables,
    TContext
  >({
    mutationKey: ['PurchaseUpgradeProduct'],
    mutationFn: (variables?: PurchaseUpgradeProductMutationVariables) =>
      fetcher<PurchaseUpgradeProductMutation, PurchaseUpgradeProductMutationVariables>(
        client,
        PurchaseUpgradeProductDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const StripeSettingsDocument = `
    query StripeSettings {
  getUserSettings {
    stripeAccountStatus
    stripeAccountStatusDescription
    acceptingPayments
    acceptingPaymentsStartedAt
    payoutsEnabled
    payoutsEnabledStartedAt
    stripeVerifiedAt
    timezone
  }
}
    `;

export const useStripeSettingsQuery = <TData = StripeSettingsQuery, TError = unknown>(
  client: GraphQLClient,
  variables?: StripeSettingsQueryVariables,
  options?: Omit<UseQueryOptions<StripeSettingsQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<StripeSettingsQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers']
) => {
  return useQuery<StripeSettingsQuery, TError, TData>({
    queryKey: variables === undefined ? ['StripeSettings'] : ['StripeSettings', variables],
    queryFn: fetcher<StripeSettingsQuery, StripeSettingsQueryVariables>(
      client,
      StripeSettingsDocument,
      variables,
      headers
    ),
    ...options,
  });
};

export const UpdateUserDocument = `
    mutation UpdateUser($input: updateUserInput!) {
  updateUser(input: $input) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;

export const useUpdateUserMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>,
  headers?: RequestInit['headers']
) => {
  return useMutation<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>({
    mutationKey: ['UpdateUser'],
    mutationFn: (variables?: UpdateUserMutationVariables) =>
      fetcher<UpdateUserMutation, UpdateUserMutationVariables>(
        client,
        UpdateUserDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const UpgradeAuthorSubscriptionDocument = `
    mutation UpgradeAuthorSubscription($input: upgradeAuthorSubscriptionInput!) {
  upgradeAuthorSubscription(input: $input) {
    checkoutUrl
  }
}
    `;

export const useUpgradeAuthorSubscriptionMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    UpgradeAuthorSubscriptionMutation,
    TError,
    UpgradeAuthorSubscriptionMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers']
) => {
  return useMutation<
    UpgradeAuthorSubscriptionMutation,
    TError,
    UpgradeAuthorSubscriptionMutationVariables,
    TContext
  >({
    mutationKey: ['UpgradeAuthorSubscription'],
    mutationFn: (variables?: UpgradeAuthorSubscriptionMutationVariables) =>
      fetcher<UpgradeAuthorSubscriptionMutation, UpgradeAuthorSubscriptionMutationVariables>(
        client,
        UpgradeAuthorSubscriptionDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const GetUserDocument = `
    query GetUser($username: String!) {
  getUser(username: $username) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;

export const useGetUserQuery = <TData = GetUserQuery, TError = unknown>(
  client: GraphQLClient,
  variables: GetUserQueryVariables,
  options?: Omit<UseQueryOptions<GetUserQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetUserQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers']
) => {
  return useQuery<GetUserQuery, TError, TData>({
    queryKey: ['GetUser', variables],
    queryFn: fetcher<GetUserQuery, GetUserQueryVariables>(
      client,
      GetUserDocument,
      variables,
      headers
    ),
    ...options,
  });
};

export const VerifyEmailCodeDocument = `
    mutation VerifyEmailCode($input: verifyEmailCodeInput!) {
  verifyEmailCode(input: $input) {
    ...UserSessionFragment
  }
}
    ${UserSessionFragmentFragmentDoc}`;

export const useVerifyEmailCodeMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    VerifyEmailCodeMutation,
    TError,
    VerifyEmailCodeMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers']
) => {
  return useMutation<VerifyEmailCodeMutation, TError, VerifyEmailCodeMutationVariables, TContext>({
    mutationKey: ['VerifyEmailCode'],
    mutationFn: (variables?: VerifyEmailCodeMutationVariables) =>
      fetcher<VerifyEmailCodeMutation, VerifyEmailCodeMutationVariables>(
        client,
        VerifyEmailCodeDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const GetAudienceDocument = `
    query GetAudience($productId: ID!) {
  getAudience(productId: $productId) {
    id
    customer {
      id
      name
      username
      email
      avatarUrl
    }
    tier {
      id
      title
      orderNumber
    }
    progress
    joinedAt
  }
}
    `;

export const useGetAudienceQuery = <TData = GetAudienceQuery, TError = unknown>(
  client: GraphQLClient,
  variables: GetAudienceQueryVariables,
  options?: Omit<UseQueryOptions<GetAudienceQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetAudienceQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers']
) => {
  return useQuery<GetAudienceQuery, TError, TData>({
    queryKey: ['GetAudience', variables],
    queryFn: fetcher<GetAudienceQuery, GetAudienceQueryVariables>(
      client,
      GetAudienceDocument,
      variables,
      headers
    ),
    ...options,
  });
};

export const GetProductsStatsDocument = `
    query GetProductsStats($productId: ID) {
  getProductsStats(productId: $productId) {
    productId
    stats {
      revenue
      sales
      views
      courseCompletions
    }
  }
}
    `;

export const useGetProductsStatsQuery = <TData = GetProductsStatsQuery, TError = unknown>(
  client: GraphQLClient,
  variables?: GetProductsStatsQueryVariables,
  options?: Omit<UseQueryOptions<GetProductsStatsQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetProductsStatsQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers']
) => {
  return useQuery<GetProductsStatsQuery, TError, TData>({
    queryKey: variables === undefined ? ['GetProductsStats'] : ['GetProductsStats', variables],
    queryFn: fetcher<GetProductsStatsQuery, GetProductsStatsQueryVariables>(
      client,
      GetProductsStatsDocument,
      variables,
      headers
    ),
    ...options,
  });
};

export const GetTotalStatsDocument = `
    query GetTotalStats {
  getTotalStats {
    revenue
    sales
    views
    courseCompletions
  }
}
    `;

export const useGetTotalStatsQuery = <TData = GetTotalStatsQuery, TError = unknown>(
  client: GraphQLClient,
  variables?: GetTotalStatsQueryVariables,
  options?: Omit<UseQueryOptions<GetTotalStatsQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetTotalStatsQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers']
) => {
  return useQuery<GetTotalStatsQuery, TError, TData>({
    queryKey: variables === undefined ? ['GetTotalStats'] : ['GetTotalStats', variables],
    queryFn: fetcher<GetTotalStatsQuery, GetTotalStatsQueryVariables>(
      client,
      GetTotalStatsDocument,
      variables,
      headers
    ),
    ...options,
  });
};

export const GetTierStatsDocument = `
    query GetTierStats($productId: ID!) {
  getTierStats(productId: $productId) {
    tierId
    stats {
      views
      sales
      revenue
      courseCompletions
      progress
    }
  }
}
    `;

export const useGetTierStatsQuery = <TData = GetTierStatsQuery, TError = unknown>(
  client: GraphQLClient,
  variables: GetTierStatsQueryVariables,
  options?: Omit<UseQueryOptions<GetTierStatsQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetTierStatsQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers']
) => {
  return useQuery<GetTierStatsQuery, TError, TData>({
    queryKey: ['GetTierStats', variables],
    queryFn: fetcher<GetTierStatsQuery, GetTierStatsQueryVariables>(
      client,
      GetTierStatsDocument,
      variables,
      headers
    ),
    ...options,
  });
};

export const PageContentChangedDocument = `
    subscription PageContentChanged($pageId: ID!) {
  pageContentChanged(pageId: $pageId) {
    ...PageFragment
  }
}
    ${PageFragmentFragmentDoc}`;
export const TriggerPageContentChangedDocument = `
    mutation TriggerPageContentChanged($triggerPageContentChangedId: ID!) {
  triggerPageContentChanged(id: $triggerPageContentChangedId) {
    id
  }
}
    `;

export const useTriggerPageContentChangedMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    TriggerPageContentChangedMutation,
    TError,
    TriggerPageContentChangedMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers']
) => {
  return useMutation<
    TriggerPageContentChangedMutation,
    TError,
    TriggerPageContentChangedMutationVariables,
    TContext
  >({
    mutationKey: ['TriggerPageContentChanged'],
    mutationFn: (variables?: TriggerPageContentChangedMutationVariables) =>
      fetcher<TriggerPageContentChangedMutation, TriggerPageContentChangedMutationVariables>(
        client,
        TriggerPageContentChangedDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const GetProductManagementDocument = `
    query GetProductManagement($productId: ID!) {
  getProduct(id: $productId) {
    ...ProductFragment
  }
  getPages(productId: $productId) {
    ...PageInListFragment
  }
  getTiers(productId: $productId) {
    ...TierFragment
  }
  getLanding(productId: $productId) {
    ...LandingFragment
  }
}
    ${ProductFragmentFragmentDoc}
${PageInListFragmentFragmentDoc}
${TierFragmentFragmentDoc}
${LandingFragmentFragmentDoc}`;

export const useGetProductManagementQuery = <TData = GetProductManagementQuery, TError = unknown>(
  client: GraphQLClient,
  variables: GetProductManagementQueryVariables,
  options?: Omit<UseQueryOptions<GetProductManagementQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetProductManagementQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers']
) => {
  return useQuery<GetProductManagementQuery, TError, TData>({
    queryKey: ['GetProductManagement', variables],
    queryFn: fetcher<GetProductManagementQuery, GetProductManagementQueryVariables>(
      client,
      GetProductManagementDocument,
      variables,
      headers
    ),
    ...options,
  });
};

export const GetCustomVideoDocument = `
    query GetCustomVideo($guid: ID!) {
  getCustomVideo(guid: $guid) {
    id
    guid
    status
    transcodingProgress
  }
}
    `;

export const useGetCustomVideoQuery = <TData = GetCustomVideoQuery, TError = unknown>(
  client: GraphQLClient,
  variables: GetCustomVideoQueryVariables,
  options?: Omit<UseQueryOptions<GetCustomVideoQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetCustomVideoQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers']
) => {
  return useQuery<GetCustomVideoQuery, TError, TData>({
    queryKey: ['GetCustomVideo', variables],
    queryFn: fetcher<GetCustomVideoQuery, GetCustomVideoQueryVariables>(
      client,
      GetCustomVideoDocument,
      variables,
      headers
    ),
    ...options,
  });
};

export const GetLandingDocument = `
    query GetLanding($getLandingProductId: ID!) {
  getLanding(productId: $getLandingProductId) {
    ...LandingFragment
  }
}
    ${LandingFragmentFragmentDoc}`;

export const useGetLandingQuery = <TData = GetLandingQuery, TError = unknown>(
  client: GraphQLClient,
  variables: GetLandingQueryVariables,
  options?: Omit<UseQueryOptions<GetLandingQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetLandingQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers']
) => {
  return useQuery<GetLandingQuery, TError, TData>({
    queryKey: ['GetLanding', variables],
    queryFn: fetcher<GetLandingQuery, GetLandingQueryVariables>(
      client,
      GetLandingDocument,
      variables,
      headers
    ),
    ...options,
  });
};

export const GetPublishedLandingDocument = `
    query GetPublishedLanding($getPublishedLandingProductId: ID!) {
  getPublishedLanding(productId: $getPublishedLandingProductId) {
    ...LandingFragment
  }
}
    ${LandingFragmentFragmentDoc}`;

export const useGetPublishedLandingQuery = <TData = GetPublishedLandingQuery, TError = unknown>(
  client: GraphQLClient,
  variables: GetPublishedLandingQueryVariables,
  options?: Omit<UseQueryOptions<GetPublishedLandingQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetPublishedLandingQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers']
) => {
  return useQuery<GetPublishedLandingQuery, TError, TData>({
    queryKey: ['GetPublishedLanding', variables],
    queryFn: fetcher<GetPublishedLandingQuery, GetPublishedLandingQueryVariables>(
      client,
      GetPublishedLandingDocument,
      variables,
      headers
    ),
    ...options,
  });
};

export const UpdateLandingDocument = `
    mutation UpdateLanding($input: updateLandingInput!) {
  updateLanding(input: $input) {
    ...LandingFragment
  }
}
    ${LandingFragmentFragmentDoc}`;

export const useUpdateLandingMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    UpdateLandingMutation,
    TError,
    UpdateLandingMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers']
) => {
  return useMutation<UpdateLandingMutation, TError, UpdateLandingMutationVariables, TContext>({
    mutationKey: ['UpdateLanding'],
    mutationFn: (variables?: UpdateLandingMutationVariables) =>
      fetcher<UpdateLandingMutation, UpdateLandingMutationVariables>(
        client,
        UpdateLandingDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const ArchivePageDocument = `
    mutation ArchivePage($archivePageId: ID!) {
  archivePage(id: $archivePageId)
}
    `;

export const useArchivePageMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<ArchivePageMutation, TError, ArchivePageMutationVariables, TContext>,
  headers?: RequestInit['headers']
) => {
  return useMutation<ArchivePageMutation, TError, ArchivePageMutationVariables, TContext>({
    mutationKey: ['ArchivePage'],
    mutationFn: (variables?: ArchivePageMutationVariables) =>
      fetcher<ArchivePageMutation, ArchivePageMutationVariables>(
        client,
        ArchivePageDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const CancelScheduledPagePublishDocument = `
    mutation CancelScheduledPagePublish($id: ID!) {
  cancelScheduledPagePublish(id: $id)
}
    `;

export const useCancelScheduledPagePublishMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    CancelScheduledPagePublishMutation,
    TError,
    CancelScheduledPagePublishMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers']
) => {
  return useMutation<
    CancelScheduledPagePublishMutation,
    TError,
    CancelScheduledPagePublishMutationVariables,
    TContext
  >({
    mutationKey: ['CancelScheduledPagePublish'],
    mutationFn: (variables?: CancelScheduledPagePublishMutationVariables) =>
      fetcher<CancelScheduledPagePublishMutation, CancelScheduledPagePublishMutationVariables>(
        client,
        CancelScheduledPagePublishDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const CreatePageDocument = `
    mutation CreatePage($input: addPageInput!) {
  addPage(input: $input) {
    ...PageFragment
  }
}
    ${PageFragmentFragmentDoc}`;

export const useCreatePageMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<CreatePageMutation, TError, CreatePageMutationVariables, TContext>,
  headers?: RequestInit['headers']
) => {
  return useMutation<CreatePageMutation, TError, CreatePageMutationVariables, TContext>({
    mutationKey: ['CreatePage'],
    mutationFn: (variables?: CreatePageMutationVariables) =>
      fetcher<CreatePageMutation, CreatePageMutationVariables>(
        client,
        CreatePageDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const GetPageDocument = `
    query GetPage($getPageId: ID!) {
  getPage(id: $getPageId) {
    ...PageFragment
    isPurchased
  }
}
    ${PageFragmentFragmentDoc}`;

export const useGetPageQuery = <TData = GetPageQuery, TError = unknown>(
  client: GraphQLClient,
  variables: GetPageQueryVariables,
  options?: Omit<UseQueryOptions<GetPageQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetPageQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers']
) => {
  return useQuery<GetPageQuery, TError, TData>({
    queryKey: ['GetPage', variables],
    queryFn: fetcher<GetPageQuery, GetPageQueryVariables>(
      client,
      GetPageDocument,
      variables,
      headers
    ),
    ...options,
  });
};

export const GetPagesDocument = `
    query GetPages($productId: ID!) {
  getPages(productId: $productId) {
    ...PageInListFragment
  }
}
    ${PageInListFragmentFragmentDoc}`;

export const useGetPagesQuery = <TData = GetPagesQuery, TError = unknown>(
  client: GraphQLClient,
  variables: GetPagesQueryVariables,
  options?: Omit<UseQueryOptions<GetPagesQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetPagesQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers']
) => {
  return useQuery<GetPagesQuery, TError, TData>({
    queryKey: ['GetPages', variables],
    queryFn: fetcher<GetPagesQuery, GetPagesQueryVariables>(
      client,
      GetPagesDocument,
      variables,
      headers
    ),
    ...options,
  });
};

export const GetPublishedPageDocument = `
    query GetPublishedPage($getPublishedProductId: ID!, $getPublishedPageId: ID!) {
  getPublishedPage(productId: $getPublishedProductId, id: $getPublishedPageId) {
    ...PageFragment
    isPurchased
  }
}
    ${PageFragmentFragmentDoc}`;

export const useGetPublishedPageQuery = <TData = GetPublishedPageQuery, TError = unknown>(
  client: GraphQLClient,
  variables: GetPublishedPageQueryVariables,
  options?: Omit<UseQueryOptions<GetPublishedPageQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetPublishedPageQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers']
) => {
  return useQuery<GetPublishedPageQuery, TError, TData>({
    queryKey: ['GetPublishedPage', variables],
    queryFn: fetcher<GetPublishedPageQuery, GetPublishedPageQueryVariables>(
      client,
      GetPublishedPageDocument,
      variables,
      headers
    ),
    ...options,
  });
};

export const GetPublishedPagesDocument = `
    query GetPublishedPages($productId: ID!) {
  getPublishedPages(productId: $productId) {
    ...PageInListFragment
  }
}
    ${PageInListFragmentFragmentDoc}`;

export const useGetPublishedPagesQuery = <TData = GetPublishedPagesQuery, TError = unknown>(
  client: GraphQLClient,
  variables: GetPublishedPagesQueryVariables,
  options?: Omit<UseQueryOptions<GetPublishedPagesQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetPublishedPagesQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers']
) => {
  return useQuery<GetPublishedPagesQuery, TError, TData>({
    queryKey: ['GetPublishedPages', variables],
    queryFn: fetcher<GetPublishedPagesQuery, GetPublishedPagesQueryVariables>(
      client,
      GetPublishedPagesDocument,
      variables,
      headers
    ),
    ...options,
  });
};

export const PublishPageDocument = `
    mutation PublishPage($id: ID!) {
  publishPage(id: $id)
}
    `;

export const usePublishPageMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<PublishPageMutation, TError, PublishPageMutationVariables, TContext>,
  headers?: RequestInit['headers']
) => {
  return useMutation<PublishPageMutation, TError, PublishPageMutationVariables, TContext>({
    mutationKey: ['PublishPage'],
    mutationFn: (variables?: PublishPageMutationVariables) =>
      fetcher<PublishPageMutation, PublishPageMutationVariables>(
        client,
        PublishPageDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const ReadPageDocument = `
    mutation ReadPage($id: ID!) {
  completePage(id: $id) {
    pageCompleted
    courseCompleted
  }
}
    `;

export const useReadPageMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<ReadPageMutation, TError, ReadPageMutationVariables, TContext>,
  headers?: RequestInit['headers']
) => {
  return useMutation<ReadPageMutation, TError, ReadPageMutationVariables, TContext>({
    mutationKey: ['ReadPage'],
    mutationFn: (variables?: ReadPageMutationVariables) =>
      fetcher<ReadPageMutation, ReadPageMutationVariables>(
        client,
        ReadPageDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const SchedulePagePublishDocument = `
    mutation SchedulePagePublish($input: schedulePagePublishInput!) {
  schedulePagePublish(input: $input)
}
    `;

export const useSchedulePagePublishMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    SchedulePagePublishMutation,
    TError,
    SchedulePagePublishMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers']
) => {
  return useMutation<
    SchedulePagePublishMutation,
    TError,
    SchedulePagePublishMutationVariables,
    TContext
  >({
    mutationKey: ['SchedulePagePublish'],
    mutationFn: (variables?: SchedulePagePublishMutationVariables) =>
      fetcher<SchedulePagePublishMutation, SchedulePagePublishMutationVariables>(
        client,
        SchedulePagePublishDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const UnpublishPageDocument = `
    mutation UnpublishPage($unpublishPageId: ID!) {
  unpublishPage(id: $unpublishPageId)
}
    `;

export const useUnpublishPageMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    UnpublishPageMutation,
    TError,
    UnpublishPageMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers']
) => {
  return useMutation<UnpublishPageMutation, TError, UnpublishPageMutationVariables, TContext>({
    mutationKey: ['UnpublishPage'],
    mutationFn: (variables?: UnpublishPageMutationVariables) =>
      fetcher<UnpublishPageMutation, UnpublishPageMutationVariables>(
        client,
        UnpublishPageDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const UpdatePageDocument = `
    mutation UpdatePage($input: updatePageInput!) {
  updatePage(input: $input) {
    ...PageFragment
  }
}
    ${PageFragmentFragmentDoc}`;

export const useUpdatePageMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<UpdatePageMutation, TError, UpdatePageMutationVariables, TContext>,
  headers?: RequestInit['headers']
) => {
  return useMutation<UpdatePageMutation, TError, UpdatePageMutationVariables, TContext>({
    mutationKey: ['UpdatePage'],
    mutationFn: (variables?: UpdatePageMutationVariables) =>
      fetcher<UpdatePageMutation, UpdatePageMutationVariables>(
        client,
        UpdatePageDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const ArchiveProductDocument = `
    mutation ArchiveProduct($archiveProductId: ID!) {
  archiveProduct(id: $archiveProductId)
}
    `;

export const useArchiveProductMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    ArchiveProductMutation,
    TError,
    ArchiveProductMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers']
) => {
  return useMutation<ArchiveProductMutation, TError, ArchiveProductMutationVariables, TContext>({
    mutationKey: ['ArchiveProduct'],
    mutationFn: (variables?: ArchiveProductMutationVariables) =>
      fetcher<ArchiveProductMutation, ArchiveProductMutationVariables>(
        client,
        ArchiveProductDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const CancelScheduledProductPublishDocument = `
    mutation CancelScheduledProductPublish($cancelScheduledProductPublishId: ID!) {
  cancelScheduledProductPublish(id: $cancelScheduledProductPublishId)
}
    `;

export const useCancelScheduledProductPublishMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    CancelScheduledProductPublishMutation,
    TError,
    CancelScheduledProductPublishMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers']
) => {
  return useMutation<
    CancelScheduledProductPublishMutation,
    TError,
    CancelScheduledProductPublishMutationVariables,
    TContext
  >({
    mutationKey: ['CancelScheduledProductPublish'],
    mutationFn: (variables?: CancelScheduledProductPublishMutationVariables) =>
      fetcher<
        CancelScheduledProductPublishMutation,
        CancelScheduledProductPublishMutationVariables
      >(client, CancelScheduledProductPublishDocument, variables, headers)(),
    ...options,
  });
};

export const CreateProductDocument = `
    mutation CreateProduct($input: createProductInput!) {
  createProduct(input: $input) {
    ...ProductFragment
  }
}
    ${ProductFragmentFragmentDoc}`;

export const useCreateProductMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    CreateProductMutation,
    TError,
    CreateProductMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers']
) => {
  return useMutation<CreateProductMutation, TError, CreateProductMutationVariables, TContext>({
    mutationKey: ['CreateProduct'],
    mutationFn: (variables?: CreateProductMutationVariables) =>
      fetcher<CreateProductMutation, CreateProductMutationVariables>(
        client,
        CreateProductDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const DuplicateProductDocument = `
    mutation DuplicateProduct($input: duplicateProductInput!) {
  duplicateProduct(input: $input) {
    ...ProductFragment
  }
}
    ${ProductFragmentFragmentDoc}`;

export const useDuplicateProductMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    DuplicateProductMutation,
    TError,
    DuplicateProductMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers']
) => {
  return useMutation<DuplicateProductMutation, TError, DuplicateProductMutationVariables, TContext>(
    {
      mutationKey: ['DuplicateProduct'],
      mutationFn: (variables?: DuplicateProductMutationVariables) =>
        fetcher<DuplicateProductMutation, DuplicateProductMutationVariables>(
          client,
          DuplicateProductDocument,
          variables,
          headers
        )(),
      ...options,
    }
  );
};

export const GetProductDocument = `
    query GetProduct($getProductId: ID!) {
  getProduct(id: $getProductId) {
    ...ProductFragment
  }
}
    ${ProductFragmentFragmentDoc}`;

export const useGetProductQuery = <TData = GetProductQuery, TError = unknown>(
  client: GraphQLClient,
  variables: GetProductQueryVariables,
  options?: Omit<UseQueryOptions<GetProductQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetProductQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers']
) => {
  return useQuery<GetProductQuery, TError, TData>({
    queryKey: ['GetProduct', variables],
    queryFn: fetcher<GetProductQuery, GetProductQueryVariables>(
      client,
      GetProductDocument,
      variables,
      headers
    ),
    ...options,
  });
};

export const GetProductsDocument = `
    query GetProducts($username: String!, $filter: getProductsFilter) {
  getProducts(username: $username, filter: $filter) {
    ...ProductFragment
  }
}
    ${ProductFragmentFragmentDoc}`;

export const useGetProductsQuery = <TData = GetProductsQuery, TError = unknown>(
  client: GraphQLClient,
  variables: GetProductsQueryVariables,
  options?: Omit<UseQueryOptions<GetProductsQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetProductsQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers']
) => {
  return useQuery<GetProductsQuery, TError, TData>({
    queryKey: ['GetProducts', variables],
    queryFn: fetcher<GetProductsQuery, GetProductsQueryVariables>(
      client,
      GetProductsDocument,
      variables,
      headers
    ),
    ...options,
  });
};

export const GetPublishedProductDocument = `
    query GetPublishedProduct($getPublishedProductId: ID!) {
  getPublishedProduct(id: $getPublishedProductId) {
    ...ProductFragment
  }
}
    ${ProductFragmentFragmentDoc}`;

export const useGetPublishedProductQuery = <TData = GetPublishedProductQuery, TError = unknown>(
  client: GraphQLClient,
  variables: GetPublishedProductQueryVariables,
  options?: Omit<UseQueryOptions<GetPublishedProductQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetPublishedProductQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers']
) => {
  return useQuery<GetPublishedProductQuery, TError, TData>({
    queryKey: ['GetPublishedProduct', variables],
    queryFn: fetcher<GetPublishedProductQuery, GetPublishedProductQueryVariables>(
      client,
      GetPublishedProductDocument,
      variables,
      headers
    ),
    ...options,
  });
};

export const GetPublishedProductsDocument = `
    query GetPublishedProducts($username: String!, $filter: getPublishedProductsFilter) {
  getPublishedProducts(username: $username, filter: $filter) {
    ...ProductFragment
  }
}
    ${ProductFragmentFragmentDoc}`;

export const useGetPublishedProductsQuery = <TData = GetPublishedProductsQuery, TError = unknown>(
  client: GraphQLClient,
  variables: GetPublishedProductsQueryVariables,
  options?: Omit<UseQueryOptions<GetPublishedProductsQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetPublishedProductsQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers']
) => {
  return useQuery<GetPublishedProductsQuery, TError, TData>({
    queryKey: ['GetPublishedProducts', variables],
    queryFn: fetcher<GetPublishedProductsQuery, GetPublishedProductsQueryVariables>(
      client,
      GetPublishedProductsDocument,
      variables,
      headers
    ),
    ...options,
  });
};

export const PublishProductDocument = `
    mutation PublishProduct($input: publishProductInput!) {
  publishProduct(input: $input)
}
    `;

export const usePublishProductMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    PublishProductMutation,
    TError,
    PublishProductMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers']
) => {
  return useMutation<PublishProductMutation, TError, PublishProductMutationVariables, TContext>({
    mutationKey: ['PublishProduct'],
    mutationFn: (variables?: PublishProductMutationVariables) =>
      fetcher<PublishProductMutation, PublishProductMutationVariables>(
        client,
        PublishProductDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const GetPurchasedProductsDocument = `
    query GetPurchasedProducts {
  getPurchasedProducts {
    id
    amountInCents
    amountCurrency
    purchasedAt
    product {
      ...ProductFragment
    }
    tier {
      ...TierFragment
    }
  }
}
    ${ProductFragmentFragmentDoc}
${TierFragmentFragmentDoc}`;

export const useGetPurchasedProductsQuery = <TData = GetPurchasedProductsQuery, TError = unknown>(
  client: GraphQLClient,
  variables?: GetPurchasedProductsQueryVariables,
  options?: Omit<UseQueryOptions<GetPurchasedProductsQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetPurchasedProductsQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers']
) => {
  return useQuery<GetPurchasedProductsQuery, TError, TData>({
    queryKey:
      variables === undefined ? ['GetPurchasedProducts'] : ['GetPurchasedProducts', variables],
    queryFn: fetcher<GetPurchasedProductsQuery, GetPurchasedProductsQueryVariables>(
      client,
      GetPurchasedProductsDocument,
      variables,
      headers
    ),
    ...options,
  });
};

export const ScheduleProductPublishDocument = `
    mutation ScheduleProductPublish($input: scheduleProductPublishInput!) {
  scheduleProductPublish(input: $input)
}
    `;

export const useScheduleProductPublishMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    ScheduleProductPublishMutation,
    TError,
    ScheduleProductPublishMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers']
) => {
  return useMutation<
    ScheduleProductPublishMutation,
    TError,
    ScheduleProductPublishMutationVariables,
    TContext
  >({
    mutationKey: ['ScheduleProductPublish'],
    mutationFn: (variables?: ScheduleProductPublishMutationVariables) =>
      fetcher<ScheduleProductPublishMutation, ScheduleProductPublishMutationVariables>(
        client,
        ScheduleProductPublishDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const UnpublishProductDocument = `
    mutation UnpublishProduct($unpublishProductId: ID!) {
  unpublishProduct(id: $unpublishProductId)
}
    `;

export const useUnpublishProductMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    UnpublishProductMutation,
    TError,
    UnpublishProductMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers']
) => {
  return useMutation<UnpublishProductMutation, TError, UnpublishProductMutationVariables, TContext>(
    {
      mutationKey: ['UnpublishProduct'],
      mutationFn: (variables?: UnpublishProductMutationVariables) =>
        fetcher<UnpublishProductMutation, UnpublishProductMutationVariables>(
          client,
          UnpublishProductDocument,
          variables,
          headers
        )(),
      ...options,
    }
  );
};

export const UpdateProductDocument = `
    mutation UpdateProduct($input: updateProductInput!) {
  updateProduct(input: $input) {
    ...ProductFragment
  }
}
    ${ProductFragmentFragmentDoc}`;

export const useUpdateProductMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    UpdateProductMutation,
    TError,
    UpdateProductMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers']
) => {
  return useMutation<UpdateProductMutation, TError, UpdateProductMutationVariables, TContext>({
    mutationKey: ['UpdateProduct'],
    mutationFn: (variables?: UpdateProductMutationVariables) =>
      fetcher<UpdateProductMutation, UpdateProductMutationVariables>(
        client,
        UpdateProductDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const CreateProductFolderDocument = `
    mutation CreateProductFolder($input: createProductFolderInput!) {
  createProductFolder(input: $input) {
    ...ProductFolderFragment
  }
}
    ${ProductFolderFragmentFragmentDoc}`;

export const useCreateProductFolderMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    CreateProductFolderMutation,
    TError,
    CreateProductFolderMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers']
) => {
  return useMutation<
    CreateProductFolderMutation,
    TError,
    CreateProductFolderMutationVariables,
    TContext
  >({
    mutationKey: ['CreateProductFolder'],
    mutationFn: (variables?: CreateProductFolderMutationVariables) =>
      fetcher<CreateProductFolderMutation, CreateProductFolderMutationVariables>(
        client,
        CreateProductFolderDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const GetProductFoldersDocument = `
    query GetProductFolders($userId: ID!) {
  getProductFolders(userId: $userId) {
    ...ProductFolderFragment
  }
}
    ${ProductFolderFragmentFragmentDoc}`;

export const useGetProductFoldersQuery = <TData = GetProductFoldersQuery, TError = unknown>(
  client: GraphQLClient,
  variables: GetProductFoldersQueryVariables,
  options?: Omit<UseQueryOptions<GetProductFoldersQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetProductFoldersQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers']
) => {
  return useQuery<GetProductFoldersQuery, TError, TData>({
    queryKey: ['GetProductFolders', variables],
    queryFn: fetcher<GetProductFoldersQuery, GetProductFoldersQueryVariables>(
      client,
      GetProductFoldersDocument,
      variables,
      headers
    ),
    ...options,
  });
};

export const GetProductTemplatesDocument = `
    query GetProductTemplates {
  getProductTemplates {
    id
    slug
    url
    title
    description
    pictureUrl
    createdAt
    updatedAt
  }
}
    `;

export const useGetProductTemplatesQuery = <TData = GetProductTemplatesQuery, TError = unknown>(
  client: GraphQLClient,
  variables?: GetProductTemplatesQueryVariables,
  options?: Omit<UseQueryOptions<GetProductTemplatesQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetProductTemplatesQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers']
) => {
  return useQuery<GetProductTemplatesQuery, TError, TData>({
    queryKey:
      variables === undefined ? ['GetProductTemplates'] : ['GetProductTemplates', variables],
    queryFn: fetcher<GetProductTemplatesQuery, GetProductTemplatesQueryVariables>(
      client,
      GetProductTemplatesDocument,
      variables,
      headers
    ),
    ...options,
  });
};

export const ArchiveTierDocument = `
    mutation ArchiveTier($archiveTierInput: archiveTierInput!) {
  archiveTier(input: $archiveTierInput)
}
    `;

export const useArchiveTierMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<ArchiveTierMutation, TError, ArchiveTierMutationVariables, TContext>,
  headers?: RequestInit['headers']
) => {
  return useMutation<ArchiveTierMutation, TError, ArchiveTierMutationVariables, TContext>({
    mutationKey: ['ArchiveTier'],
    mutationFn: (variables?: ArchiveTierMutationVariables) =>
      fetcher<ArchiveTierMutation, ArchiveTierMutationVariables>(
        client,
        ArchiveTierDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const GetPublishedFreeTierDocument = `
    query GetPublishedFreeTier($productId: ID!) {
  getPublishedFreeTier(productId: $productId) {
    ...TierFragment
  }
}
    ${TierFragmentFragmentDoc}`;

export const useGetPublishedFreeTierQuery = <TData = GetPublishedFreeTierQuery, TError = unknown>(
  client: GraphQLClient,
  variables: GetPublishedFreeTierQueryVariables,
  options?: Omit<UseQueryOptions<GetPublishedFreeTierQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetPublishedFreeTierQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers']
) => {
  return useQuery<GetPublishedFreeTierQuery, TError, TData>({
    queryKey: ['GetPublishedFreeTier', variables],
    queryFn: fetcher<GetPublishedFreeTierQuery, GetPublishedFreeTierQueryVariables>(
      client,
      GetPublishedFreeTierDocument,
      variables,
      headers
    ),
    ...options,
  });
};

export const GetPublishedTiersDocument = `
    query GetPublishedTiers($productId: ID!, $promocode: ID) {
  getPublishedTiers(productId: $productId, promocode: $promocode) {
    ...TierFragment
  }
}
    ${TierFragmentFragmentDoc}`;

export const useGetPublishedTiersQuery = <TData = GetPublishedTiersQuery, TError = unknown>(
  client: GraphQLClient,
  variables: GetPublishedTiersQueryVariables,
  options?: Omit<UseQueryOptions<GetPublishedTiersQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetPublishedTiersQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers']
) => {
  return useQuery<GetPublishedTiersQuery, TError, TData>({
    queryKey: ['GetPublishedTiers', variables],
    queryFn: fetcher<GetPublishedTiersQuery, GetPublishedTiersQueryVariables>(
      client,
      GetPublishedTiersDocument,
      variables,
      headers
    ),
    ...options,
  });
};

export const GetTiersDocument = `
    query GetTiers($productId: ID!, $promocode: ID) {
  getTiers(productId: $productId, promocode: $promocode) {
    ...TierFragment
  }
}
    ${TierFragmentFragmentDoc}`;

export const useGetTiersQuery = <TData = GetTiersQuery, TError = unknown>(
  client: GraphQLClient,
  variables: GetTiersQueryVariables,
  options?: Omit<UseQueryOptions<GetTiersQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetTiersQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers']
) => {
  return useQuery<GetTiersQuery, TError, TData>({
    queryKey: ['GetTiers', variables],
    queryFn: fetcher<GetTiersQuery, GetTiersQueryVariables>(
      client,
      GetTiersDocument,
      variables,
      headers
    ),
    ...options,
  });
};

export const UpdateTiersDocument = `
    mutation UpdateTiers($input: updateTiersInput!) {
  updateTiers(input: $input) {
    ...TierFragment
  }
}
    ${TierFragmentFragmentDoc}`;

export const useUpdateTiersMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<UpdateTiersMutation, TError, UpdateTiersMutationVariables, TContext>,
  headers?: RequestInit['headers']
) => {
  return useMutation<UpdateTiersMutation, TError, UpdateTiersMutationVariables, TContext>({
    mutationKey: ['UpdateTiers'],
    mutationFn: (variables?: UpdateTiersMutationVariables) =>
      fetcher<UpdateTiersMutation, UpdateTiersMutationVariables>(
        client,
        UpdateTiersDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const GettingStartedUpdatedDocument = `
    subscription GettingStartedUpdated($userId: ID!) {
  gettingStartedUpdated(userId: $userId) {
    ...GettingStartedFragment
  }
}
    ${GettingStartedFragmentFragmentDoc}`;
export const UpdateCustomVideoDocument = `
    mutation UpdateCustomVideo($input: updateCustomVideoInput!) {
  updateCustomVideo(input: $input) {
    id
    guid
    status
    transcodingProgress
    title
    url
    thumbnailUrl
    createdAt
    updatedAt
  }
}
    `;

export const useUpdateCustomVideoMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    UpdateCustomVideoMutation,
    TError,
    UpdateCustomVideoMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers']
) => {
  return useMutation<
    UpdateCustomVideoMutation,
    TError,
    UpdateCustomVideoMutationVariables,
    TContext
  >({
    mutationKey: ['UpdateCustomVideo'],
    mutationFn: (variables?: UpdateCustomVideoMutationVariables) =>
      fetcher<UpdateCustomVideoMutation, UpdateCustomVideoMutationVariables>(
        client,
        UpdateCustomVideoDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export const UploadNewVideoDocument = `
    mutation UploadNewVideo($input: uploadNewVideoInput!) {
  uploadNewVideo(input: $input) {
    headers
  }
}
    `;

export const useUploadNewVideoMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    UploadNewVideoMutation,
    TError,
    UploadNewVideoMutationVariables,
    TContext
  >,
  headers?: RequestInit['headers']
) => {
  return useMutation<UploadNewVideoMutation, TError, UploadNewVideoMutationVariables, TContext>({
    mutationKey: ['UploadNewVideo'],
    mutationFn: (variables?: UploadNewVideoMutationVariables) =>
      fetcher<UploadNewVideoMutation, UploadNewVideoMutationVariables>(
        client,
        UploadNewVideoDocument,
        variables,
        headers
      )(),
    ...options,
  });
};

export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {},
};
export default result;
